import {
  SECTIONS,
  NOTIFICATION_TYPES,
  OPERATIONS,
} from "../../../../config/constants";
import {
  EXTRACTION_STEP_PARAMETERS,
  EXTRACTION_PROCEDURE_NAMES,
  EXTRACTION_IMPORT_TYPES,
  BATCH_PROCESSING_CRON_REPEAT_TYPE,
  BATCH_PROCESSING_OCCURRENCE_TYPE,
  EXTRACTION_SOURCE_TYPES,
  IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS,
  IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS,
} from "../../../../config/consts/extraction";
import PageHead from "../../../layout/PageHead";
import {
  Select,
  Button,
  Form,
  Input,
  Divider,
  Steps,
  Upload,
  Spin,
  AutoComplete,
  Radio,
  RadioChangeEvent,
  DatePicker,
  Space,
  InputNumber,
  Modal, Checkbox,
} from "antd";
import "./Extraction.css";
import {
  CheckOutlined,
  CloudDownloadOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
  UploadOutlined,
  ExperimentOutlined, CheckCircleOutlined, CloseCircleOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import GroupCodesService from "../../../../services/groupcodes/GroupCodesService";
import TablesService from "../../../../services/tables/TablesService";
import styles from "../extraction/Extraction.module.css";
import type { UploadChangeParam, UploadFile } from "antd/es/upload/interface";
import ExtractionService from "../../../../services/extraction/ExtractionService";
import { ExtractRequest } from "../../../../models/extraction/ExtractRequest";
import { ExtractCreateRequest } from "../../../../models/extraction/ExtractCreateRequest";
import { ExtractUpdateRequest } from "../../../../models/extraction/ExtractUpdateRequest";
import { GetTablesRequest } from "../../../../models/tables/GetTablesRequest";
import DatabaseService from "../../../../services/databases/DatabaseService";
import { useTranslation } from "react-i18next";
import NotificationsUtil from "../../../shared/utils/NotificationsUtil";
import { useForm } from "antd/es/form/Form";
import history from "../../../shared/utils/HistoryUtil";
import ProjectSourceService from "../../../../services/projectsources/ProjectSourceService";
import BatchProcessingService from "../../../../services/batchprocessing/BatchProcessingService";
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";
import { SharepointFileNameResponse } from "../../../../models/extraction/SharepointFileNameResponse";
import { ROUTES } from "../../../../config/consts/routes";
import { useNavigate } from "react-router-dom";
import { setEntity, setExtractionResultTableParams, setGroupCode } from "../../../../redux/actions";
import { useDispatch } from "react-redux";
import ApplicationService from "../../../../services/application/ApplicationService";
import {
  GLOBAL_COMPONENT_SELECT_DATABASE_IMPORT_DEFAULT,
  TABLE_SETUP_HIDE_SYSTEM_FIELDS
} from "../../../../config/consts/appsettings";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { ExtractSharepointFileRequest } from "../../../../models/extraction/ExtractSharepointFileRequest";
import { ExtractFileFromRepositoryRequest } from "../../../../models/extraction/ExtractFileFromRepositoryRequest";
import { System } from "../../../../models/system/System";
import SystemService from "../../../../services/sytem/SystemService";
import { Entity } from "../../../../models/entities/Entity";

const { Step } = Steps;

const routes = [
  {
    path: ROUTES.general.main.route,
    breadcrumbName: SECTIONS.general.name,
  },
  {
    breadcrumbName: SECTIONS.operation.name,
  },
  {
    path: ROUTES.operation.import.route,
    breadcrumbName: ROUTES.operation.import.name,
  },
];

const Extraction = () => {
  const { Option } = Select;
  const { t, i18n } = useTranslation("translations");
  const [extractionForm] = useForm();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedSource, setSelectedSource] = useState<any>(null);
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [selectedTableType, setSelectedTableType] = useState<any>(null);
  const [selectedOperation, setSelectedOperation] = useState<any>(null);
  const [selectedTable, setSelectedTable] = useState<any>(null);

  const [fromTables, setFromTables] = useState<any>([]);
  const [targetTables, setTargetTables] = useState<any>([]);
  const [selectedFromTable, setSelectedFromTable] = useState<any>();

  const [groupCodes, setGroupCodes] = useState<any>([]);
  const [entities, setEntities] = useState<any>([]);
  const [operations, setOperations] = useState<any>([]);
  const [databases, setDatabases] = useState<any>([]);
  const [projectSources, setProjectSources] = useState<any>([]);
  const [headSelectedOperation, setHeadSelectedOperation] = useState<any>();

  const [selectedGroupCode, setSelectedGroupCode] = useState<any>();
  const [selectedEntity, setSelectedEntity] = useState<any>();
  const [selectedSystemId, setSelectedSystemId] = useState<number>(null);
  const [stepTemplates, setStepTemplates] = useState<any>([]);

  const [fileRepositoryFileNames, setFileRepositoryFileNames] = useState<string[]>([]);
  const [sharepointFileNames, setSharepointFileNames] = useState<SharepointFileNameResponse[]>([]);
  const [selectedFileName, setSelectedFileName] = useState<string>("");
  const [selectedProjectSource, setSelectedProjectSource] = useState<any>({});

  const [selectedProjectDataSource, setSelectedProjectDataSource] = useState<any>();
  const [selectedDatabaseObject, setSelectedDatabaseObject] = useState<any>();
  const [databaseTables, setDatabaseTables] = useState<any>([]);
  const [selectedDatabaseTable, setSelectedDatabaseTable] = useState<any>();
  const [databaseObjectIsSelected, setDatabaseObjectIsSelected] = useState<any>(false);
  const [importType, setImportType] = useState<any>();
  const [sourceQuery, setSourceQuery] = useState<any>();


  const [fileRepositorySource, setFileRepositorySource] = useState<any>();

  const [extractedColumns, setExtractedColumns] = useState<any>([]);
  const [importedColumns, setImportedColumns] = useState<any>([]);
  const [duplicateColumns, setDuplicateColumns] = useState<any>([]);
  const [existingColumns, setExistingColumns] = useState<string[]>([]);
  const [showWarning, setShowWarning] = useState(false);

  const [isExtracting, setIsExtracting] = useState<any>();

  const [current, setCurrent] = useState(0);

  const [database, setDatabase] = useState<any>();
  const [schema, setSchema] = useState<any>();
  const [name, setName] = useState<any>();

  const [isLoading, setIsLoading] = useState<any>(true);
  const [extractionDone, setExtractionDone] = useState<boolean>(false);
  const [extractionRecords, setExtractionRecords] = useState<number>(0);
  const [extractionSuccessful, setExtractionSuccessful] = useState<boolean>(false);
  const [extractionFailedDescription, setExtractionFailedDescription] = useState<string>('');

  const [selectedFileList, setSelectedFileList] = useState<any>([]);

  const [isDirty, setIsDirty] = useState<any>(false);
  const [isChecked, setIsChecked] = useState(false);

  const [databaseObjectInput, setdatabseObjectInput] = useState<any>("");

  const [testConnectionState, setTestConnectionState] = useState<any>(null);

  // const [scheduleType, setScheduleType] = useState(1);
  const [scheduleDateTime, setScheduleDateTime] = useState<any>(null);
  const [scheduleType, setScheduleType] = useState(BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY);
  const [endType, setEndType] = useState<any>("Never");
  const [startDate, setStartDate] = useState<any>(moment());
  const [endDate, setEndDate] = useState<any>();
  const [repeatCount, setRepeatCount] = useState<number>(1);
  const [repeatType, setRepeatType] = useState<any>("day");
  const defaultCronExpression = "0 0 * * *";
  const [cronExpression, setCronExpression] = useState(defaultCronExpression);
  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  const [isRedirectModalOpen, setIsRedirectModalOpen] = useState(false);

  const [preferences, setPreferences] = useState<any>();
  const [isCheckboxChanged, setIsCheckboxChanged] = useState<boolean>(false);

  const [systems, setSystems] = useState<System[]>([]);
  const [systemOptions, setSystemOptions] = useState<SystemOptionGroup[]>([]);

  type SystemOptionGroup = {
    label: React.ReactNode;
    title: string;
    options: { label: string; value: number }[];
  };

  const importTypes = [
    {
      id: EXTRACTION_IMPORT_TYPES.DATABASE_OBJECT,
      label: EXTRACTION_IMPORT_TYPES.DATABASE_OBJECT,
      value: EXTRACTION_IMPORT_TYPES.DATABASE_OBJECT
    },
    {
      id: EXTRACTION_IMPORT_TYPES.CUSTOM_QUERY,
      label: EXTRACTION_IMPORT_TYPES.CUSTOM_QUERY,
      value: EXTRACTION_IMPORT_TYPES.CUSTOM_QUERY
    },
  ];

  useEffect(() => {
    SystemService.getAll()
      .then((res) => {
        setSystems(res.data);
        setSystemOptions([{
          label: <span>Other systems</span>,
          title: 'Other systems',
          options: res.data.map(x => ({
            label: x.name,
            value: x.id,
          })),
        }]);
      });
  }, []);

  // Update loading state when extractedColumns are defined
  useEffect(() => {
    if (extractedColumns.length > 0) {
      setIsLoading(false);
    }
  }, [extractedColumns]);

  useEffect(() => {
    document.title = ROUTES.operation.import.name;
  }, []);

  useEffect(() => {
    if (!isDirty) return;

    const unblock = history.block((tx: any) => {
      if (
        window.confirm(
          "Are you sure you want leave the page without saving? Current changes will be lost."
        )
      ) {
        unblock();
        tx.retry();
      }
    });

    return () => {
      unblock();
    };
  }, [isDirty]);

  useEffect(() => {
    if (selectedTableType === "new") {
      setSelectedTable(null);
    }
    setExistingColumns([]);
  }, [selectedTableType])

  useEffect(() => {
    GroupCodesService.getAll().then((response: any) => {
      const data = response.data;
      setGroupCodes(data);
    });
    TablesService.getAllEntities().then((response: any) => {
      const data = response.data;
      setEntities(data);
    });
    DatabaseService.getAll().then((response: any) => {
      const data = response.data;
      setDatabases(data);
    });
    ProjectSourceService.getAll().then((response: any) => {
      const data = response.data;
      setProjectSources(data);
    });
    ApplicationService.getPreferences().then((response: any) => {
      const data = response.data;
      setPreferences(data);
    });
    TablesService.getAllOperations().then((response: any) => {
      const data = response.data;
      setOperations(data);
    });
  }, []);

  useEffect(() => {
    if (operations) {
      setHeadSelectedOperation(OPERATIONS.IMPORT)
    }
  }, [operations]);

  useEffect(() => {
    if (selectedGroupCode && selectedEntity) {
      const model: GetTablesRequest = {
        groupCode: selectedGroupCode,
        entityId: selectedEntity,
        operationId: 1,
      };

      TablesService.getTables(model).then((response: any) => {
        const data = response.data;
        if (data && data.length > 0) {
          setFromTables(data);
          setTargetTables(data);
          setSelectedFromTable(data[0]);
        }
      });
    }
  }, [selectedGroupCode, selectedEntity]);

  useEffect(() => {
    if (extractedColumns?.length > 0) {
      const duplicates: any = [];
      extractedColumns.filter((x: any, index: any) => {
        if (extractedColumns.indexOf(x) !== index) {
          duplicates.push(index);
          duplicates.push(extractedColumns.indexOf(x));
        }
      });

      setDuplicateColumns(duplicates);
    }
  }, [extractedColumns]);

  useEffect(() => {
    const model = {
      entity: entities.find((x: any) => x.id === selectedEntity)?.name,
      groupcode: selectedGroupCode,
    };
    BatchProcessingService.getAllStepTemplates(model).then(
      (response: any) => {
        setStepTemplates(response.data);
      }
    );
  }, []);

  useEffect(() => {
    if (selectedProjectDataSource) {
      const selectedDataSource = projectSources.find((x: any) => x.id.toString() === selectedProjectDataSource.id)

      const model = {
        projectSourceId: selectedDataSource?.id.toString(),
      }
      ExtractionService.getTables(model).then((response: any) => {
        setDatabaseTables(response.data);
      });
    }
  }, [selectedProjectDataSource]);

  useEffect(() => {
    if (scheduleType === BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING) {
      // generate cron expression
      let cronExpression: string;

      switch (repeatType) {
        case "minute":
          // every nth minute
          cronExpression = `*/${repeatCount} * * * *`;
          break;
        case "hour":
          // every nth hour
          cronExpression = `${startDate?.minute()} */${repeatCount} * * *`;
          break;
        case "day":
          // at time on every -nth day
          cronExpression = `${startDate?.minute()} ${startDate?.hour()} */${repeatCount} * *`;
          break;
        case "week":
          setRepeatCount(1);
          // at time on nth day of the week
          cronExpression = `${startDate?.minute()} ${startDate?.hour()} * * ${startDate?.day()}`;
          break;
        case "month":
          // at time on day of the month every -nth month
          cronExpression = `${startDate?.minute()} ${startDate?.hour()} ${startDate?.date()} */${repeatCount} *`;
          break;
        case "year":
          setRepeatCount(1);
          // at 00:00 on first day of the year
          cronExpression = `${startDate?.minute()} ${startDate?.hour()} ${startDate?.date()} ${startDate?.month()} *`;
          break;
        default:
          // every minute
          cronExpression = "* * * * *";
          break;
      }
      setCronExpression(cronExpression);
    }
  }, [repeatType, repeatCount, startDate, scheduleType]);

  useEffect(() => {
    if (scheduleType === BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING) {
      setRepeatCount(1);
      setRepeatType("day");
      setStartDate(moment());
      setEndDate(null);
      // setCronExpression("0 0 * * *");
    } else {
      setCronExpression("");
    }
  }, [scheduleType]);

  const steps = [
    {
      title: t("Page.Operation.Import.Labels.StepperSelectSourceType", {
        lngs: i18n.languages,
        defaultValue: "Select source type",
      }),
      content: t(
        "Page.Operation.Import.Labels.StepperSelectSourceTypeDescription",
        { lngs: i18n.languages, defaultValue: "Data extraction source" }
      ),
      visible: true,
    },
    {
      title: t("Page.Operation.Import.Labels.StepperFillSourceData", {
        lngs: i18n.languages,
        defaultValue: "Fill source data",
      }),
      content: t(
        "Page.Operation.Import.Labels.StepperFillSourceDataDescription",
        { lngs: i18n.languages, defaultValue: "Source dataset" }
      ),
      disabled: current === 0 && !selectedSource,
      visible: selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER ? true : false,
    },
    {
      title: t(
        "Page.Operation.Extraction.Labels.StepperSelectProjectDataSource",
        {
          lngs: i18n.languages,
          defaultValue: "Select project source",
        }
      ),
      content: t(
        "Page.Operation.Extraction.Labels.StepperSelectProjectDataSourceDescription",
        {
          lngs: i18n.languages,
          defaultValue: "Select predefined project data source",
        }
      ),
      disabled: current === 0 && !selectedSource,
      visible: selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL ||
        selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY ||
        selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT,
    },
    {
      title: t(
        "Page.Operation.Extraction.Labels.StepperSelectDestinationType",
        { lngs: i18n.languages, defaultValue: "Select destination type" }
      ),
      content: t(
        "Page.Operation.Extraction.Labels.StepperSelectDestinationTypeDescription",
        { lngs: i18n.languages, defaultValue: "Existing or new table?" }
      ),
      disabled:
        (current === 0 && !selectedSource) || (current === 1 && !selectedFile),
      visible: selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER ? true : false,
      onClick: () => next(),
    },
    {
      title: t("Page.Operation.Extraction.Labels.StepperFillDestinationData", {
        lngs: i18n.languages,
        defaultValue: "Fill destination data",
      }),
      content: t(
        "Page.Operation.Extraction.Labels.StepperFillDestinationDataDescription",
        { lngs: i18n.languages, defaultValue: "Destination information" }
      ),
      disabled:
        (current === 0 && !selectedSource) ||
        (current === 1 &&
          selectedSource == EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
          !selectedFile) ||
        (current === 1 &&
          selectedSource !== EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
          !selectedProjectDataSource) ||
        (current === 2 &&
          selectedSource == EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
          !selectedTableType) ||
        (current === 3 &&
          selectedSource == EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
          selectedTableType === "new" &&
          (!selectedGroupCode ||
            !selectedEntity ||
            !database ||
            !schema ||
            !name)) ||
        (current === 3 &&
          selectedSource == EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
          selectedTableType === "existing" &&
          (!selectedOperation ||
            !selectedGroupCode ||
            !selectedEntity ||
            !selectedTable)),
      onClick: () => next(),
      visible: selectedSource ? true : false,
    },
    {
      title: t("Page.Operation.Extraction.Labels.StepperSelectExecutionType", {
        lngs: i18n.languages,
        defaultValue: "Execution type",
      }),
      content: t(
        "Page.Operation.Extraction.Labels.StepperSelectExecutionTypeDescription",
        { lngs: i18n.languages, defaultValue: "Execute now or schedule a job" }
      ),
      disabled:
        (current === 0 && !selectedSource) ||
        (current === 1 && !selectedProjectDataSource) ||
        (current === 2 &&
          (!selectedGroupCode ||
            !selectedEntity ||
            !database ||
            !schema ||
            !name)),
      visible: selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL ||
        selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY ||
        selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT,
    },
    {
      title: t("Page.Operation.Extraction.Labels.StepperConfirmTableHeaders", {
        lngs: i18n.languages,
        defaultValue: "Confirm table headers",
      }),
      content: t(
        "Page.Operation.Extraction.Labels.StepperConfirmTableHeadersDescription",
        { lngs: i18n.languages, defaultValue: "Table headers" }
      ),
      disabled:
        (current === 0 && !selectedSource) ||
        (current === 1 && !selectedFile) ||
        (current === 2 && !selectedTableType) ||
        (current === 3 &&
          selectedTableType === "new" &&
          (!selectedGroupCode ||
            !selectedEntity ||
            !database ||
            !schema ||
            !name)) ||
        (current === 3 &&
          selectedTableType === "existing" &&
          (!selectedOperation ||
            !selectedGroupCode ||
            !selectedEntity ||
            !selectedTable)),
      onClick: () => extract(),
      visible: selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER ||
        selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY ||
        selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT ||
        selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL 

    },
  ];

  const handleSourceChange = (value: string) => {
    setIsDirty(true);
    setSelectedSource(value);
    setSelectedProjectDataSource(null);
    setFileRepositoryFileNames([]);
    setSharepointFileNames([]);
    next();
  };

  const handleFileChange = (value: UploadChangeParam<UploadFile>) => {
    setIsDirty(true);
    if (value.fileList.length === 0) {
      setSelectedFile(null);
      setSelectedFileList([]);
    } else {
      setSelectedFile(value?.fileList[0].originFileObj);
      setSelectedFileList(value?.fileList);
      next();
    }
  };

  const handleTableTypeChange = (value: string) => {
    setIsDirty(true);
    setSelectedTableType(value);
    next();
  };

  const onGroupCodeChange = (value: string) => {
    setIsDirty(true);
    setSelectedGroupCode(value);
  };
  const onEntityChange = (value: string) => {
    setIsDirty(true);
    setSelectedEntity(value);

    // reorder systems based on entity source system ids
    const sourceSystemIds = entities.find((x: any) => x.id === value)?.sourceSystemIds ?? [];
    const sourceSystems = systems.filter(system => sourceSystemIds.includes(system.id));
    const otherSystems = systems.filter(system => !sourceSystemIds.includes(system.id));

    // group with label for "Source systems" en "Other systems"
    const groupedSystems = [];
    if (sourceSystems.length > 0) {
      groupedSystems.push({
        label: <span>Entity source systems</span>,
        title: 'Source systems',
        options: sourceSystems.map(x => ({
          label: x.name,
          value: x.id,
        })),
      });
    }
    if (otherSystems.length > 0) {
      groupedSystems.push({
        label: <span>Other systems</span>,
        title: 'Other systems',
        options: otherSystems.map(x => ({
          label: x.name,
          value: x.id,
        })),
      });
    }
    setSystemOptions(groupedSystems);
    setSchema(entities.find((x: any) => x.id === value)?.name);

    const appDefaultDatabase = preferences.find(
      (p) =>
        p.key === GLOBAL_COMPONENT_SELECT_DATABASE_IMPORT_DEFAULT &&
        p.object === "Application"
    );

    let initialDatabase = null;

    if (value) {
      const entityDefaultDatabase = preferences.find(
        (p) =>
          p.key === GLOBAL_COMPONENT_SELECT_DATABASE_IMPORT_DEFAULT &&
          p.object === "Entity" &&
          p.objectId === value
      );

      if (entityDefaultDatabase) {
        initialDatabase = entityDefaultDatabase.value;
      }
    }

    if (initialDatabase === null) {
      if (appDefaultDatabase) {
        initialDatabase = appDefaultDatabase.value;
      }
    }

    if (initialDatabase === null) {
      if (databases.length === 1) {
        initialDatabase = databases[0].name;
      }
    }
    setDatabase(initialDatabase);
    extractionForm.setFieldsValue({ database: initialDatabase });
  };

  const onOperationChange = (value: string) => {
    setIsDirty(true);
    setSelectedOperation(value);
  };

  const onTableChange = (value: string) => {
    setIsDirty(true);
    setSelectedTable(value);
  };

  const onDatabaseChange = (value: string) => {
    setIsDirty(true);
    setDatabase(value);
  };

  const onSchemaChange = (value: string) => {
    setIsDirty(true);
    setSchema(value);
  };

  const onNameChange = (value: string) => {
    setIsDirty(true);
    if (/^[A-Za-z0-9_]*$/.test(value)) {
      setName(value.replace(/\s/g, ""));
    }
  };

  const onHeaderColumnChange = (value: string, index: number) => {
    if (/^[A-Za-z0-9_]*$/.test(value)) {
      let newData = [...extractedColumns];
      newData[index] = value.replace(/\s/g, "");
      setExtractedColumns(newData);
    }
  };

  const preventRequest = () => false;

  const extract = () => {
    const model: ExtractRequest = {
      file: selectedFile,
    };
    setIsExtracting(true);

    ExtractionService.extract(model.file, selectedTable)
      .then((response: any) => {
        const existingColumnHeaders = response.data.existingColumnHeaders;
        const existingColumnHeadersTrimmed = existingColumnHeaders.map((x: any) =>
          x.replace(/[^a-z0-9_]/gim, "")
        );
        setExistingColumns(existingColumnHeadersTrimmed);

        const extractedColumnHeaders = response.data.extractedColumnHeaders;
        const extractedColumnHeadersTrimmed = extractedColumnHeaders.map((x: any) =>
          x.replace(/[^a-z0-9_]/gim, "")
        );

        setExtractedColumns(extractedColumnHeadersTrimmed);
        setImportedColumns(extractedColumnHeaders);
        setIsExtracting(false);
      })
      .catch((error: any) => {
        if (error.response.data) {
          NotificationsUtil.openNotificationDialog({
            description: error.response.data,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        } else {
          NotificationsUtil.openNotificationDialog({
            description: t(
              "Page.Operation.Extraction.Notifications.Extraction.ExtractionErrorDescription",
              {
                lngs: i18n.languages,
                defaultValue:
                  "Unexpected error occurred. Please try again or contact system administrators.",
              }
            )!,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        }

        setIsExtracting(false);
      });
  };

  const extractSharePoint = () => {
    const selectedDataSource = projectSources.find((x: any) => x.id.toString() === selectedProjectDataSource.id)

    const model: ExtractSharepointFileRequest = {
      fileId: selectedFileName,
      folderRelativePath: selectedDataSource?.locationPath,
      projectSourceId: selectedDataSource?.id.toString(),
      destinationTableId: -1,

    };
    setIsExtracting(true);

    ExtractionService.extractSharePoint(model.fileId, model.folderRelativePath, model.projectSourceId, model.destinationTableId)
      .then((response: any) => {
        const existingColumnHeaders = response.data.existingColumnHeaders;
        const existingColumnHeadersTrimmed = existingColumnHeaders.map((x: any) =>
          x.replace(/[^a-z0-9_]/gim, "")
        );
        setExistingColumns(existingColumnHeadersTrimmed);

        const extractedColumnHeaders = response.data.extractedColumnHeaders;
        const extractedColumnHeadersTrimmed = extractedColumnHeaders.map((x: any) =>
          x.replace(/[^a-z0-9_]/gim, "")
        );

        setExtractedColumns(extractedColumnHeadersTrimmed);
        setImportedColumns(extractedColumnHeaders);
        setIsExtracting(false);
      })
      .catch((error: any) => {
        if (error.response.data) {
          NotificationsUtil.openNotificationDialog({
            description: error.response.data,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        } else {
          NotificationsUtil.openNotificationDialog({
            description: t(
              "Page.Operation.Extraction.Notifications.Extraction.ExtractionErrorDescription",
              {
                lngs: i18n.languages,
                defaultValue:
                  "Unexpected error occurred. Please try again or contact system administrators.",
              }
            )!,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        }

        setIsExtracting(false);
      });
  };

  const extractFileFromRepository = () => {
    const selectedDataSource = projectSources.find((x: any) => x.id.toString() === selectedProjectDataSource.id)

    const model: ExtractFileFromRepositoryRequest = {
      path: selectedDataSource?.locationPath + '/' + selectedFileName,
      destinationTableId: -1,
    };
    setIsExtracting(true);

    ExtractionService.extractFileFromRepository(model.path, model.destinationTableId)
      .then((response: any) => {
        const existingColumnHeaders = response.data.existingColumnHeaders;
        const existingColumnHeadersTrimmed = existingColumnHeaders.map((x: any) =>
          x.replace(/[^a-z0-9_]/gim, "")
        );
        setExistingColumns(existingColumnHeadersTrimmed);

        const extractedColumnHeaders = response.data.extractedColumnHeaders;
        const extractedColumnHeadersTrimmed = extractedColumnHeaders.map((x: any) =>
          x.replace(/[^a-z0-9_]/gim, "")
        );

        setExtractedColumns(extractedColumnHeadersTrimmed);
        setImportedColumns(extractedColumnHeaders);
        setIsExtracting(false);
      })
      .catch((error: any) => {
        if (error.response.data) {
          NotificationsUtil.openNotificationDialog({
            description: error.response.data,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        } else {
          NotificationsUtil.openNotificationDialog({
            description: t(
              "Page.Operation.Extraction.Notifications.Extraction.ExtractionErrorDescription",
              {
                lngs: i18n.languages,
                defaultValue:
                  "Unexpected error occurred. Please try again or contact system administrators.",
              }
            )!,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        }

        setIsExtracting(false);
      });
  };

  const handleExtraction = () => {
    setIsLoading(true);

    const selectedDataSource = selectedProjectDataSource
        ? projectSources?.find((x: any) => x.id.toString() === selectedProjectDataSource.id)
        : null;
    
    
    if (selectedTableType === "new") {
      const model: ExtractCreateRequest = {
        entity: selectedEntity,
        groupCode: selectedGroupCode,
        database: database,
        schema: schema,
        table: name,
        fields: extractedColumns,
        file: selectedFile,
        keys: checkedKeys,
        systemId: selectedSystemId,
        sourceId: selectedDataSource ? selectedDataSource.id : null,
      };

      if (duplicateColumns?.length > 0) {
        NotificationsUtil.openNotificationDialog({
          description: "There are duplicate column names specified. Column names must be unique.",
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });

        setIsLoading(false);
        return;
      }

      ExtractionService.create(model)
        .then((response) => {
          setExtractionRecords(response.data);
          NotificationsUtil.openNotificationDialog({
            description: t("Page.Operation.Extraction.Notifications.Extraction.CreateSuccessDescription", {
              lngs: i18n.languages,
              defaultValue: `Extraction completed. Extracted ${response.data} records.`,
            })!,
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });
          setIsLoading(false);
          setExtractionDone(true);
          setExtractionSuccessful(true);
          setIsDirty(false);
        })
        .catch((error: any) => {
          let errorResponse = '';

          if (error.response.data.Message) {
            errorResponse = error.response.data.Message;
          } else if (error.response.data) {
            errorResponse = error.response.data;
          } else if (error.response.Message) {
            errorResponse = error.response.Message;
          } else {
            errorResponse = "Unexpected error: " + error.message + ". Please contact administrators.";
          }

          setExtractionFailedDescription(errorResponse);
          NotificationsUtil.openNotificationDialog({
            message: "Extraction failed",
            description: errorResponse,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });

          setExtractionFailedDescription(errorResponse);
          setIsLoading(false);
          setExtractionDone(true);
          setExtractionSuccessful(false);
          setIsDirty(false);
        });
    } else {
      const model: ExtractUpdateRequest = {
        fields: extractedColumns,
        file: selectedFile,
        fromTableId: selectedFromTable?.id,
        targetTableId: selectedTable,
        operationType: selectedOperation,
        existingFields: existingColumns,
        keys: checkedKeys,
      };

      ExtractionService.update(model)
        .then((response) => {
          NotificationsUtil.openNotificationDialog({
            description: t("Page.Operation.Extraction.Notifications.Extraction.UpdateSuccessDescription", {
              lngs: i18n.languages,
              defaultValue: `Extraction completed. Extracted ${response.data} records.`,
            })!,
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });
          setIsLoading(false);
          setExtractionDone(true);
          setExtractionSuccessful(true);
          setIsDirty(false);
        })
        .catch((error: any) => {
          let errorResponse = '';
          if (error.response.data.Message) {
            errorResponse = error.response.data.Message;
          } else if (error.response.data) {
            errorResponse = error.response.data;
          } else if (error.response.Message) {
            errorResponse = error.response.Message;
          } else {
            errorResponse = "Unexpected error: " + error.message + ". Please contact administrators.";
          }

          NotificationsUtil.openNotificationDialog({
            description: error.response.data,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });

          setExtractionFailedDescription(errorResponse);
          setIsLoading(false);
          setExtractionDone(true);
          setExtractionSuccessful(false);
          setIsDirty(false);
        });
    }
  };

  const extractSQL = () => {
    if (!selectedDatabaseObject && sourceQuery) {
      ExtractionService.getFieldsFromQuery(sourceQuery).then((response: any) => {
        setExtractedColumns(response.data);
        setImportedColumns(response.data);
      });
    } else {
      ExtractionService.getFields(selectedProjectDataSource?.id, selectedDatabaseObject).then((response: any) => {
        setExtractedColumns(response.data);
        setImportedColumns(response.data);
      });
    }
  };

  const showProceedToBatchProcessingModal = () => {
    setIsRedirectModalOpen(true);
  };

  const completeExtraction = () => {
    if (Array.isArray(checkedKeys) && checkedKeys.length === 0 && (importType === EXTRACTION_IMPORT_TYPES.DATABASE_OBJECT || importType === EXTRACTION_IMPORT_TYPES.CUSTOM_QUERY)) {
      Modal.confirm({
        title: "Warning",
        content: "You have not selected any keys for this import table. Datashaper will not be able to assign the unique code for each record automatically. This means you will need to map the code manually. Are you sure you want to continue?",
        onOk() {
          handleExtraction();
          showProceedToBatchProcessingModal();
        },
      });
    } else {
      handleExtraction();
    }
  };

  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent(current - 1);
    setIsCheckboxChanged(false);
    setExtractionDone(false);
  };

  const customRequest = (options: any) => {
    // options?.onSuccess?("ok")
  };

  const onStepChange = (value: number) => {
    if (value === 4) {
      extract();
    }

    setCurrent(value);
  };

  const isDuplicateColumnName = (idx: number) => {
    for (let i = 0; i < duplicateColumns.length; i++) {
      if (idx === duplicateColumns[i]) {
        return true;
      }
    }
    return false;
  };

  const isNewColumn = (columnName: string) => {
    if (!existingColumns.length) {
      return false;
    }

    return !existingColumns.includes(columnName);
  }

  const onDatabaseObjectInputChange = (value: string) => {
    setdatabseObjectInput(value);
    if (value !== "" && current === 1) {
      next();
    }
  };

  const onProjectDataSourceSelect = (value: string, option: any) => {
    setTestConnectionState(null);
    setSelectedProjectDataSource(option);

    if (selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY || selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT) {
      getFileNamesFromRepository(option);
    }

    if (option && current === 1) {
      next();
    }
  };

  const onSelectedDatabaseObjectChange = (value: string) => {
    setSelectedDatabaseObject(value);
    setDatabaseObjectIsSelected(false);

    const databaseObjectNames = value?.split(".");
    if (databaseObjectNames?.length === 2) {
      setName(databaseObjectNames[1]);
    }
  };

  const onSelectedDatabaseObjectSelect = (value: string) => {
    if (value !== "") {
      setDatabaseObjectIsSelected(true);
    }
  };

  const testConnection = () => {
    const selectedDataSource = projectSources.find((x: any) => x.id.toString() === selectedProjectDataSource.id)

    const model = {
      projectSourceId: selectedDataSource.id.toString(),
    }

    ExtractionService.testConnection(model)
      .then((response: any) => {
        const data = response.data;
        setTestConnectionState(data);
      })
      .catch((error: any) => {
        console.log(error);
        setTestConnectionState(false);
      });
  };

  const getFileNamesFromRepository = (projectDataSource: any) => {
    const selectedProjectSource = projectSources.find(
      (x: any) => x.id === +projectDataSource.id
    );
    setSelectedProjectSource(selectedProjectSource);

    if (selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY) {
      ExtractionService.getFileNamesFromRepository(selectedProjectSource.locationPath).then((response) => {
        setFileRepositoryFileNames(response.data);
      });
    }

    if (selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT) {
      ExtractionService.getSharePointFiles(selectedProjectSource.locationPath, selectedProjectSource.id).then((response) => {
        setSharepointFileNames(response.data);
      });
    }
  }

  const testFileRepositoryPath = async () => {
    ExtractionService.testFileRepositoryConnection(selectedProjectSource.locationPath).then((response) => {
      setTestConnectionState(response.data);
    });
  };

  const testSharePointConnection = async () => {
    ExtractionService.testSharePointConnection(selectedProjectSource.id, '', '', '', '', '').then((response) => {
      setTestConnectionState(response.data);
    });
  };

  const onFileNameChange = (value) => {
    setSelectedFileName(value);
  }

  const createExtractionTask = () => {

    const proceedWithImmediateFileRepositoryExtraction = () => {
      setIsLoading(true);
      next();

      const model = {
        destinationSchema: schema ? schema : "",
        destinationTableName: name ? name : "",
        destinationEntity: selectedEntity ? selectedEntity.toString() : "",
        destinationGroupCode: selectedGroupCode ? selectedGroupCode : "",
        destinationDatabase: database ? database : "",
        filePath: `${selectedProjectSource.locationPath}/${selectedFileName}`,
        sourceId: selectedProjectDataSource.id,
        checkedKeys: checkedKeys ? checkedKeys.join(",") : "",
        systemId: selectedSystemId,
      }

      ExtractionService.extractFileRepository(model).then((response: any) => {
        NotificationsUtil.openNotificationDialog({
          description: t("Page.Operation.Extraction.Notifications.Extraction.CreateSuccessDescription", {
            lngs: i18n.languages,
            defaultValue: `Extraction completed.`,
          })!,
          type: NOTIFICATION_TYPES.SUCCESS,
          logError: false,
        });
        setIsLoading(false);
        setExtractionDone(true);
        setExtractionSuccessful(true);
        setIsDirty(false);
      })
        .catch((error: any) => {
          let errorResponse = '';

          if (error.response.data.Message) {
            errorResponse = error.response.data.Message;
          } else if (error.response.data) {
            errorResponse = error.response.data;
          } else if (error.response.Message) {
            errorResponse = error.response.Message;
          } else {
            errorResponse = "Unexpected error: " + error.message + ". Please contact administrators.";
          }

          setExtractionFailedDescription(errorResponse);
          NotificationsUtil.openNotificationDialog({
            message: "Extraction failed",
            description: errorResponse,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });

          setExtractionFailedDescription(errorResponse);
          setIsLoading(false);
          setExtractionDone(true);
          setExtractionSuccessful(false);
          setIsDirty(false);
        });
    }

    const proceedWithImmediateSharepointExtraction = () => {
      setIsLoading(true);
      next();

      const model = {
        destinationSchema: schema ? schema : "",
        destinationTableName: name ? name : "",
        destinationEntity: selectedEntity ? selectedEntity.toString() : "",
        destinationGroupCode: selectedGroupCode ? selectedGroupCode : "",
        destinationDatabase: database ? database : "",
        filePath: `${selectedProjectSource.server}/${selectedFileName}`,
        sourceId: selectedProjectDataSource.id,
        checkedKeys: checkedKeys ? checkedKeys.join(",") : "",
        systemId: selectedSystemId,
      }

      ExtractionService.extractSharePointProcess(model).then((response: any) => {
        NotificationsUtil.openNotificationDialog({
          description: t("Page.Operation.Extraction.Notifications.Extraction.CreateSuccessDescription", {
            lngs: i18n.languages,
            defaultValue: `Extraction completed.`,
          })!,
          type: NOTIFICATION_TYPES.SUCCESS,
          logError: false,
        });
        setIsLoading(false);
        setExtractionDone(true);
        setExtractionSuccessful(true);
        setIsDirty(false);
      })
        .catch((error: any) => {
          let errorResponse = '';

          if (error.response.data.Message) {
            errorResponse = error.response.data.Message;
          } else if (error.response.data) {
            errorResponse = error.response.data;
          } else if (error.response.Message) {
            errorResponse = error.response.Message;
          } else {
            errorResponse = "Unexpected error: " + error.message + ". Please contact administrators.";
          }

          setExtractionFailedDescription(errorResponse);
          NotificationsUtil.openNotificationDialog({
            message: "Extraction failed",
            description: errorResponse,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });

          setExtractionFailedDescription(errorResponse);
          setIsLoading(false);
          setExtractionDone(true);
          setExtractionSuccessful(false);
          setIsDirty(false);
        });
    }

    const proceedWithImmediateMsSqlExtraction = () => {
      setIsLoading(true);
      next();

      const selectedDataSource = projectSources.find(s => s.id.toString() === selectedProjectDataSource.id);

      const model = {
        sourceType: "MS SQL",
        fileName: "",
        sourceQuery: importType === EXTRACTION_IMPORT_TYPES.CUSTOM_QUERY ? sourceQuery.replace(/'/g, "''") : "",
        destinationSchema: schema ? schema : "",
        destinationTableName: name ? name : "",
        destinationEntity: selectedEntity ? selectedEntity.toString() : "",
        destinationGroupCode: selectedGroupCode ? selectedGroupCode : "",
        destinationDatabase: database ? database : "",
        sourceId: selectedDataSource.id,
        sourceTableName: importType === EXTRACTION_IMPORT_TYPES.DATABASE_OBJECT ? selectedDatabaseObject : "",
        checkedKeys: checkedKeys ? checkedKeys.join(",") : "",
        systemId: selectedSystemId
      }

      ExtractionService.extractMsSql(model).then((response: any) => {
        NotificationsUtil.openNotificationDialog({
          description: t("Page.Operation.Extraction.Notifications.Extraction.CreateSuccessDescription", {
            lngs: i18n.languages,
            defaultValue: `Extraction completed.`,
          })!,
          type: NOTIFICATION_TYPES.SUCCESS,
          logError: false,
        });
        setIsLoading(false);
        setExtractionDone(true);
        setExtractionSuccessful(true);
        setIsDirty(false);
      })
        .catch((error: any) => {
          let errorResponse = '';

          if (error.response.data.Message) {
            errorResponse = error.response.data.Message;
          } else if (error.response.data) {
            errorResponse = error.response.data;
          } else if (error.response.Message) {
            errorResponse = error.response.Message;
          } else {
            errorResponse = "Unexpected error: " + error.message + ". Please contact administrators.";
          }

          setExtractionFailedDescription(errorResponse);
          NotificationsUtil.openNotificationDialog({
            message: "Extraction failed",
            description: errorResponse,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });

          setExtractionFailedDescription(errorResponse);
          setIsLoading(false);
          setExtractionDone(true);
          setExtractionSuccessful(false);
          setIsDirty(false);
        });
    }

    const proceedWithTaskCreation = () => {
      setIsExtracting(true);

      let step;
      if (selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY) {
        step = getImportFromFileRepositoryStep();
      }
      if (selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT) {
        step = getImportFromSharePointStep();
      }
      if (selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL) {
        step = getImportFromMsSqlStep();
      }
      const selectedDataSource = projectSources.find(s => s.id.toString() === selectedProjectDataSource.id);
      
      const task = {
        name: `EXTRACT_${selectedDatabaseObject}_${schema}.${name}`,
        entity: entities.find((x: any) => x.id === selectedEntity).name,
        groupCode: selectedGroupCode,
        stepTemplates: [step],
        executeImmediate: scheduleType === BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY ? true : false,
        executionTime:
          scheduleType === BATCH_PROCESSING_OCCURRENCE_TYPE.ONE_TIME ? scheduleDateTime?.format() : null,
        cronExpression: cronExpression,
        recurringJobStartDate: startDate?.format(),
        recurringJobEndDate: endDate?.format(),
        checkedKeys: checkedKeys,
        selectedSystemId: selectedSystemId,
        sourceId: selectedDataSource.id,
      };

      BatchProcessingService.createTask(task).then((response: any) => {
        if (response.status === 200) {
          NotificationsUtil.openNotificationDialog({
            message: "Task created",
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });
          setIsRedirectModalOpen(true);
        } else {
          NotificationsUtil.openNotificationDialog({
            message: "Failed",
            description: response.statusText,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        }

        setIsExtracting(false);
        setIsDirty(false);
      }).catch((error: any) => {
        let errorResponse = "";
        if (error.response.data.Message) {
          errorResponse = error.response.data.Message;
        } else if (error.response.data) {
          errorResponse = error.response.data;
        } else if (error.response.Message) {
          errorResponse = error.response.Message;
        } else {
          errorResponse = "Unexpected error: " + error.message + ". Please contact administrators.";
        }

        NotificationsUtil.openNotificationDialog({
          message: "Extraction failed",
          description: errorResponse,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });

        setExtractionFailedDescription(errorResponse);
        setIsExtracting(false);
      });
    };

    if (Array.isArray(checkedKeys) && checkedKeys.length === 0 && (importType === EXTRACTION_IMPORT_TYPES.DATABASE_OBJECT || importType === EXTRACTION_IMPORT_TYPES.CUSTOM_QUERY)) {
      Modal.confirm({
        title: "Warning",
        content: "You have not selected any keys for this import table. Datashaper will not be able to assign the unique code for each record automatically. This means you will need to map the code manually. Are you sure you want to continue?",
        onOk() {
          if (scheduleType === BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY) {
            // check for source type
            if (selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY) {
              proceedWithImmediateFileRepositoryExtraction();
            }
            if (selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT) {
              proceedWithImmediateSharepointExtraction();
            }
            if (selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL) {
              proceedWithImmediateMsSqlExtraction();
            }
          }
          else {
            proceedWithTaskCreation();
          }
        },
      });
    } else {
      if (scheduleType === BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY) {
        // check for source type
        if (selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY) {
          proceedWithImmediateFileRepositoryExtraction();
        }
        if (selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT) {
          proceedWithImmediateSharepointExtraction();
        }
        if (selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL) {
          proceedWithImmediateMsSqlExtraction();
        }
      }
      else {
        proceedWithTaskCreation();
      }
    }
  };


  const getImportFromFileRepositoryStep = () => {
    const extractionStepTemplate = stepTemplates.find(t => t.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_FROM_FILE_REPOSITORY);

    const step = {
      procedure: {
        id: extractionStepTemplate.procedure.id,
        label: extractionStepTemplate.procedure.label
      },
      parameters: [
        ...extractionStepTemplate.parameters.map((p) => {
          let value;
          switch (p.name) {
            case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.SOURCE_ID:
              value = selectedProjectDataSource.id.toString();
              break;
            case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.FILE_PATH:
              value = `${selectedProjectSource.locationPath}/${selectedFileName}`;
              break;
            case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.DESTINATION_GROUP_CODE:
              value = selectedGroupCode ? selectedGroupCode : "";
              break;
            case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.DESTINATION_ENTITY:
              value = selectedEntity ? selectedEntity : "";
              break;
            case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.DESTINATION_DATABASE:
              value = database ? database : "";
              break;
            case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.DESTINATION_SCHEMA:
              value = schema ? schema : "";
              break;
            case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.DESTINATION_TABLE_NAME:
              value = name ? name : "";
              break;
            case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.SYSTEM_ID:
              value = selectedSystemId;
              break;
            case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.CHECKED_KEYS:
              value = checkedKeys ? checkedKeys.join(",") : "";
              break;
            default:
              value = "";
              break;
          }

          return {
            id: p.id,
            value: value
          }
        })]
    }

    return step;
  }

  const getImportFromSharePointStep = () => {
    const extractionStepTemplate = stepTemplates.find(t => t.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_FROM_SHAREPOINT);

    const step = {
      procedure: {
        id: extractionStepTemplate.procedure.id,
        label: extractionStepTemplate.procedure.label
      },
      parameters: [
        ...extractionStepTemplate.parameters.map((p) => {
          let value;
          switch (p.name) {
            case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.SOURCE_ID:
              value = selectedProjectDataSource.id.toString();
              break;
            case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.FILE_PATH:
              value = `${selectedProjectSource.server}/${selectedFileName}`;
              break;
            case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.DESTINATION_GROUP_CODE:
              value = selectedGroupCode ? selectedGroupCode : "";
              break;
            case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.DESTINATION_ENTITY:
              value = selectedEntity ? selectedEntity : "";
              break;
            case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.DESTINATION_DATABASE:
              value = database ? database : "";
              break;
            case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.DESTINATION_SCHEMA:
              value = schema ? schema : "";
              break;
            case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.DESTINATION_TABLE_NAME:
              value = name ? name : "";
              break;
            case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.CHECKED_KEYS:
              value = checkedKeys ? checkedKeys.join(",") : "";
              break;
            case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.SYSTEM_ID:
              value = selectedSystemId;
              break;
            default:
              value = "";
              break;
          }

          return {
            id: p.id,
            value: value
          }
        })]
    }

    return step;
  }

  const getImportFromMsSqlStep = () => {
    const extractionStepTemplate = stepTemplates.find(t => t.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_SOURCE);
    const selectedDataSource = projectSources.find(s => s.id.toString() === selectedProjectDataSource.id);

    const step = {
      procedure: {
        id: extractionStepTemplate.procedure.id,
        label: extractionStepTemplate.procedure.label
      },
      parameters: [
        ...extractionStepTemplate.parameters.map((p) => {
          let value;
          switch (p.name) {
            case EXTRACTION_STEP_PARAMETERS.SOURCE_TYPE:
              value = "MS SQL";
              break;
            case EXTRACTION_STEP_PARAMETERS.FILE_NAME:
              value = "";
              break;
            case EXTRACTION_STEP_PARAMETERS.SOURCE_ID:
              value = selectedDataSource.id.toString();
              break;
            case EXTRACTION_STEP_PARAMETERS.SOURCE_TABLE_NAME:
              value = importType === EXTRACTION_IMPORT_TYPES.DATABASE_OBJECT ? selectedDatabaseObject : "";
              break;
            case EXTRACTION_STEP_PARAMETERS.SOURCE_QUERY:
              value = importType === EXTRACTION_IMPORT_TYPES.CUSTOM_QUERY ? sourceQuery.replace(/'/g, "''") : "";
              break;
            case EXTRACTION_STEP_PARAMETERS.DESTINATION_SCHEMA:
              value = schema ? schema : "";
              break;
            case EXTRACTION_STEP_PARAMETERS.DESTINATION_TABLE_NAME:
              value = name ? name : "";
              break;
            case EXTRACTION_STEP_PARAMETERS.DESTINATION_ENTITY:
              value = selectedEntity ? selectedEntity : "";
              break;
            case EXTRACTION_STEP_PARAMETERS.DESTINATION_GROUP_CODE:
              value = selectedGroupCode ? selectedGroupCode : "";
              break;
            case EXTRACTION_STEP_PARAMETERS.DESTINATION_DATABASE:
              value = database ? database : "";
              break;
            case EXTRACTION_STEP_PARAMETERS.CHECKED_KEYS:
              value = checkedKeys ? checkedKeys.join(",") : "";
              break;
            case EXTRACTION_STEP_PARAMETERS.SYSTEM_ID:
              value = selectedSystemId;
              break;
            default:
              value = "";
              break;
          }

          return {
            id: p.id,
            value: value
          }
        })]
    };

    return step;
  };

  const onImportTypeChange = (value: any) => {
    setImportType(value);
    if (value && value !== "" && current === 2) {
      next();
    }
  };

  const onSourceQueryChange: React.ChangeEventHandler<HTMLTextAreaElement> = (event) => {
    setSourceQuery(event.target.value);
  };

  const handleRedirectModalOk = () => {
    setIsRedirectModalOpen(false);
    dispatch(setGroupCode(selectedGroupCode));
    dispatch(setEntity(selectedEntity));
    navigate(
      `${ROUTES.batchProcessing.processOverview.route}`
    );
  };

  const handleRedirectModalCancel = () => {
    setIsRedirectModalOpen(false);
    navigate(0); // stay on & refresh current page
  };

  const handleCheckboxChange = (idx: number) => (e: CheckboxChangeEvent) => {
    const fieldName = extractedColumns[idx];
    const newCheckedKeys = [...checkedKeys];
    if (e.target.checked) {
      if (!newCheckedKeys.includes(fieldName)) {
        newCheckedKeys.push(fieldName);
      }
    } else {
      const index = newCheckedKeys.indexOf(fieldName);
      if (index > -1) {
        newCheckedKeys.splice(index, 1);
      }
    }
    setCheckedKeys(newCheckedKeys);
    setIsCheckboxChanged(true);
  };
  const refreshPage = () => {
    navigate(0); // stay on & refresh current page
  }

  const goToTableSetup = () => {
    const model = {
      groupCode: selectedGroupCode,
      entityId: selectedEntity,
      operation: OPERATIONS.IMPORT,
      tableName: name,
    }
    dispatch(setExtractionResultTableParams(model));

    navigate(`${ROUTES.configuration.tableSetup.route}?tab=table-setup`); // go to table setup
  }

  const PickerWithType = ({
    type,
    onChange,
  }: {
    type: string;
    onChange: any;
    // | TimePickerProps["onChange"]
    // | DatePickerProps["onChange"]
    // | RangePickerProps["onChange"];
  }) => {
    if (type === BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY) {
      return null;
    }
    // return <TimePicker onChange={onChange} style={{ width: "100%" }} />;
    if (type === BATCH_PROCESSING_OCCURRENCE_TYPE.ONE_TIME) {
      return (
        <DatePicker
          placeholder={
            t("General.Placeholders.SelectOption", {
              lngs: i18n.languages,
              defaultValue: "Select option",
            })!
          }
          value={scheduleDateTime}
          showTime
          onChange={setScheduleDateTime}
          style={{ width: "100%" }}
        />
      );
    }
    if (type === BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING) {
      return (
        <>
          {/* <div>
            <Cron value={cronExpression} setValue={setCronExpression} />
          </div> */}
          <span>Repeat every:</span>
          <Space
            align="center"
            style={{ width: "100%", marginTop: "5px", marginBottom: "24px" }}
            className="reccuring_form"
          >
            <InputNumber
              min={1}
              // defaultValue={1}
              value={repeatCount}
              onChange={(x) => setRepeatCount(x)}
              style={{ width: "20%" }}
              disabled={repeatType === "year" || repeatType === "week"}
            />
            <Select
              style={{ width: "80%" }}
              placeholder="please select"
              allowClear
              value={repeatType}
              onChange={setRepeatType}
            >
              <Option value="minute">Minute</Option>
              <Option value="hour">Hour</Option>
              <Option value="day">Day</Option>
              <Option value="week">Week</Option>
              <Option value="month">Month</Option>
              <Option value="year">Year</Option>
            </Select>
          </Space>
          <span>Starts:</span>
          <Space
            align="center"
            style={{ width: "100%", marginTop: "5px" }}
            className="ending_form"
          >
            <Input allowClear value={"On"} disabled></Input>
            <DatePicker
              showTime
              style={{ width: "100%" }}
              value={startDate}
              onChange={setStartDate}
            />
          </Space>
          <span>Ends:</span>
          <Space
            align="center"
            style={{ width: "100%", marginTop: "5px" }}
            className="ending_form"
          >
            <Select
              style={{ width: "100%" }}
              placeholder="please select"
              allowClear
              value={endType}
              onChange={setEndType}
            >
              <Option value="day">Never</Option>
              <Option value="week">On</Option>
            </Select>
            <DatePicker
              showTime
              style={{ width: "100%" }}
              value={endDate}
              onChange={setEndDate}
            />
          </Space>
        </>
      );
    }
    return <DatePicker onChange={onChange} />;
  };

  return (
    <div>
      <PageHead
        title={t("Page.Operation.Import.Headers.Import", {
          lngs: i18n.languages,
          defaultValue: "Import",
        })}
        icon={<CloudDownloadOutlined />}
        routes={routes}
        groupCodes={[]}
        entities={[]}
        operations={operations}
        selectedGroupCode={selectedGroupCode}
        selectedEntity={selectedEntity}
        selectedOperation={headSelectedOperation}
        setSelectedGroupCode={setSelectedGroupCode}
        setSelectedEntity={setSelectedEntity}
        setSelectedOperation={setHeadSelectedOperation}
        setSelectGroupCodeDisabled={true}
        setSelectEntityDisabled={true}
        setSelectOperationDisabled={true}
        mainAction={[]}
        otherActions={[]}
        setActionsDisabled={true}
      />
      <div className={styles.bodyContainer}>
        <div className={styles.stepsContainer}>
          <Steps
            direction="vertical"
            size="small"
            initial={0}
            current={current}
            onChange={onStepChange}
          >
            {steps.map(
              (item) =>
                item.visible && (
                  <Step
                    key={item.title}
                    title={item.title}
                    description={item.content}
                    disabled={item.disabled}
                  />
                )
            )}
          </Steps>
        </div>
        <div className={styles.formContainer}>
          <div className="title-actions">
            <div>
              <span style={{ color: "var(--primary)" }}>
                {t("Page.Operation.Import.Headers.ExtractData", {
                  lngs: i18n.languages,
                  defaultValue: "Import data",
                })}
              </span>
            </div>
            <div className="action-buttons">
              <Button
                onClick={() => prev()}
                type={current === 0 ? "default" : "ghost"}
                size="small"
                icon={<ArrowLeftOutlined />}
                disabled={current === 0 || isLoading || isExtracting}
                hidden={extractionDone}
              >
                {t("General.Labels.Back", {
                  lngs: i18n.languages,
                  defaultValue: "Back",
                })}
              </Button>
              {(current < steps.filter(x => x.visible).length - 1) &&
                selectedSource && selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL && (
                  <Button
                    onClick={() => {
                      next();
                      extractSQL();
                    }}
                    type={
                      (current === 0 && !selectedSource) ||
                        (current === 1 && !selectedFile) ||
                        (current === 2 && !selectedTableType) ||
                        (current === 3 &&
                          selectedTableType === "new" &&
                          (!selectedGroupCode ||
                            !selectedEntity ||
                            !database ||
                            !schema ||
                            !name)) ||
                        (current === 3 &&
                          selectedTableType === "existing" &&
                          (!selectedOperation ||
                            !selectedGroupCode ||
                            !selectedEntity ||
                            !selectedTable))
                        ? "default"
                        : "ghost"
                    }
                    size="small"
                    icon={<ArrowRightOutlined />}

                    disabled={
                      (current === 0 &&
                        selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
                        !selectedSource) ||
                      (current === 1 &&
                        selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
                        !selectedFile) ||
                      (current === 2 &&
                        selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
                        !selectedTableType) ||
                      (current === 3 &&
                        selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
                        selectedTableType === "new" &&
                        (!selectedGroupCode ||
                          !selectedEntity ||
                          !database ||
                          !schema ||
                          !name)) ||
                      (current === 3 &&
                        selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
                        selectedTableType === "existing" &&
                        (!selectedOperation ||
                          !selectedGroupCode ||
                          !selectedEntity ||
                          !selectedTable)) ||
                      // (current === 1 &&
                      //   selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL &&
                      //   !selectedProjectDataSource) ||
                      (current === 2 &&
                        selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL &&
                        (!selectedGroupCode ||
                          !selectedEntity ||
                          !selectedDatabaseObject ||
                          !database ||
                          !schema ||
                          !name))
                    }
                  >
                    {t("General.Labels.Next", {
                      lngs: i18n.languages,
                      defaultValue: "Next",
                    })}
                  </Button>
                )}
              {(current < steps.filter(x => x.visible).length - 1) && (selectedSource && selectedSource !== EXTRACTION_SOURCE_TYPES.MS_SQL) && (
                <Button
                  onClick={() => {
                    if (selectedSource !== EXTRACTION_SOURCE_TYPES.SHAREPOINT && selectedSource !== EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY) {
                      extract();
                    }
                    if (selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT && current === 3) {
                      extractSharePoint();
                    }
                    if (selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY && current === 3) {
                      extractFileFromRepository();
                    }
                    next();
                  }}
                  type={
                    (current === 0 && !selectedSource) ||
                      (current === 1 && !selectedFile) ||
                      (current === 2 &&
                        selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
                        !selectedTableType) ||
                      (current === 2 &&
                        selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY &&
                        (!selectedFileName ||
                          !selectedGroupCode ||
                          !selectedEntity ||
                          !database ||
                          !schema ||
                          !name)) ||
                      (current === 3 &&
                        selectedTableType === "new" &&
                        (!selectedGroupCode ||
                          !selectedEntity ||
                          !database ||
                          !schema ||
                          !name)) ||
                      (current === 3 &&
                        selectedTableType === "existing" &&
                        (!selectedOperation ||
                          !selectedGroupCode ||
                          !selectedEntity ||
                          !selectedTable))
                      ? "default"
                      : "ghost"
                  }
                  size="small"
                  icon={<ArrowRightOutlined />}
                  hidden={extractionDone}
                  disabled={
                    (current === 0 && !selectedSource) ||
                    (current === 1 && !selectedFile) ||
                    (current === 2 &&
                      selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
                      !selectedTableType) ||
                    (current === 2 &&
                      selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY &&
                      (!selectedFileName ||
                        !selectedGroupCode ||
                        !selectedEntity ||
                        !database ||
                        !schema ||
                        !name)) ||
                    (current === 3 &&
                      selectedTableType === "new" &&
                      (!selectedGroupCode ||
                        !selectedEntity ||
                        !database ||
                        !schema ||
                        !name)) ||
                    (current === 3 &&
                      selectedTableType === "existing" &&
                      (!selectedOperation ||
                        !selectedGroupCode ||
                        !selectedEntity ||
                        !selectedTable))
                  }
                >
                  {t("General.Labels.Next", {
                    lngs: i18n.languages,
                    defaultValue: "Next",
                  })}
                </Button>
              )}
              {(current === steps.filter(x => x.visible).length - 1) && selectedSource && (selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER) && (
                <Button
                  onClick={() => completeExtraction()}
                  type={
                    extractedColumns > 0 &&
                      !isExtracting &&
                      !extractionDone &&
                      !isLoading
                      ? "primary"
                      : "default"
                  }
                  size="small"
                  hidden={extractionDone}
                  disabled={
                    extractedColumns.length === 0 ||
                    isExtracting ||
                    extractionDone ||
                    isLoading
                  }
                  // style={{color: "white"}}
                  icon={<CheckOutlined />}
                >
                  {t("Page.Operation.Extraction.Labels.Extract", {
                    lngs: i18n.languages,
                    defaultValue: "Extract",
                  })}
                </Button>
              )}
              {current === steps.filter(x => x.visible).length - 1 && selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL && (
                <>
                  <Button
                    onClick={() => {
                      extract();
                      next();
                    }}
                    type={
                      (current === 0 && !selectedSource) ||
                        (current === 1 && !selectedFile) ||
                        (current === 2 && !selectedTableType) ||
                        (current === 3 &&
                          selectedTableType === "new" &&
                          (!selectedGroupCode ||
                            !selectedEntity ||
                            !database ||
                            !schema ||
                            !name)) ||
                        (current === 3 &&
                          selectedTableType === "existing" &&
                          (!selectedOperation ||
                            !selectedGroupCode ||
                            !selectedEntity ||
                            !selectedTable))
                        ? "default"
                        : "ghost"
                    }
                    size="small"
                    icon={<ArrowRightOutlined />}
                    hidden={(selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL && current === 3) || extractionDone
                      ||
                      (current === 4 &&
                        selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL)}
                    disabled={
                      (current === 0 && !selectedSource) ||
                      (current === 1 && !selectedFile) ||
                      (current === 2 && !selectedTableType) ||
                      (current === 3 &&
                        selectedTableType === "new" &&
                        (!selectedGroupCode ||
                          !selectedEntity ||
                          !database ||
                          !schema ||
                          !name)) ||
                      (current === 3 &&
                        selectedTableType === "existing" &&
                        (!selectedOperation ||
                          !selectedGroupCode ||
                          !selectedEntity ||
                          !selectedTable))
                    }
                  >
                    {t("General.Labels.Next", {
                      lngs: i18n.languages,
                      defaultValue: "Next",
                    })}
                  </Button>
                </>
              )}
              {current === steps.filter((x) => x.visible).length - 1 &&
                (importType === EXTRACTION_IMPORT_TYPES.CUSTOM_QUERY || selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL) && (
                  <>
                    <Button
                      onClick={() => createExtractionTask()}
                      type={
                        extractedColumns > 0 &&
                          !isExtracting &&
                          !extractionDone &&
                          !isLoading
                          ? "primary"
                          : "default"
                      }
                      size="small"
                      disabled={isExtracting || (isLoading && importType === EXTRACTION_IMPORT_TYPES.DATABASE_OBJECT)}
                      hidden={extractionDone}
                      icon={<CheckOutlined />}
                    >
                      {t("Page.Operation.Extraction.Labels.Extract", {
                        lngs: i18n.languages,
                        defaultValue: "Extract",
                      })}
                    </Button>
                  </>
                )}
              {current === steps.filter((x) => x.visible).length - 1 &&
                selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY && (
                  <>
                    <Button
                      onClick={() => createExtractionTask()}
                      type={
                        extractedColumns > 0 &&
                          !isExtracting &&
                          !extractionDone &&
                          !isLoading
                          ? "primary"
                          : "default"
                      }
                      size="small"
                      disabled={isExtracting}
                      hidden={extractionDone}
                      icon={<CheckOutlined />}
                    >
                      {t("Page.Operation.Extraction.Labels.Extract", {
                        lngs: i18n.languages,
                        defaultValue: "Extract",
                      })}
                    </Button>
                  </>
                )}
              {current === steps.filter((x) => x.visible).length - 1 &&
                selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT && (
                  <>
                    <Button
                      onClick={() => createExtractionTask()}
                      type={
                        extractedColumns > 0 &&
                          !isExtracting &&
                          !extractionDone &&
                          !isLoading
                          ? "primary"
                          : "default"
                      }
                      size="small"
                      disabled={isExtracting}
                      hidden={extractionDone}
                      icon={<CheckOutlined />}
                    >
                      {t("Page.Operation.Extraction.Labels.Extract", {
                        lngs: i18n.languages,
                        defaultValue: "Extract",
                      })}
                    </Button>
                  </>
                )}
            </div>
          </div>
          <Divider />
          <div style={{ height: "calc(100% - 20px)", overflowY: "auto" }}>
            {current < 4 && (
              <Form
                form={extractionForm}
                layout="vertical"
                wrapperCol={{ span: 8 }}
                style={{ height: "95%", overflowY: "scroll", scrollbarWidth: "thin" }}
              >
                <Form.Item
                  className={styles.mb10px}
                  label={t("Page.Operation.Extraction.Labels.Source", {
                    lngs: i18n.languages,
                    defaultValue: "Source:",
                  })}
                  required
                  tooltip={t("Page.Operation.Extraction.Tooltips.Source", {
                    lngs: i18n.languages,
                    defaultValue: "",
                  })}
                >
                  <Select
                    placeholder={t("General.Placeholders.SelectOption", {
                      lngs: i18n.languages,
                      defaultValue: "Select option",
                    })}
                    allowClear
                    disabled={current !== 0}
                    value={selectedSource}
                    onChange={handleSourceChange}
                    onSelect={() => next()}
                    filterSort={(optionA, optionB) =>
                      optionA.value! < optionB.value! ? -1 : 1
                    }
                  >
                    <Option value={EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER}>
                      {t(
                        "Page.Operation.Extraction.DropdownItems.InputSourceFileOnThisComputer",
                        {
                          lngs: i18n.languages,
                          defaultValue: "File on this computer",
                        }
                      )}
                    </Option>
                    <Option value={EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY}>
                      {t(
                        "Page.Operation.Extraction.DropdownItems.InputSourceFileRepository",
                        {
                          lngs: i18n.languages,
                          defaultValue: "File Repository",
                        }
                      )}
                    </Option>
                    <Option value={EXTRACTION_SOURCE_TYPES.SHAREPOINT}>
                      {t(
                        "Page.Operation.Extraction.DropdownItems.InputSourceSharepoint",
                        {
                          lngs: i18n.languages,
                          defaultValue: "Sharepoint",
                        }
                      )}
                    </Option>
                    <Option value={EXTRACTION_SOURCE_TYPES.MS_SQL}>
                      {t(
                        "Page.Operation.Extraction.DropdownItems.InputSourceMSSQL",
                        { lngs: i18n.languages, defaultValue: "MS SQL" }
                      )}
                    </Option>
                  </Select>
                </Form.Item>
                {/* Step 2 - source Excel */}
                {current >= 1 && selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER && (
                  <Form.Item
                    className={styles.mb10px}
                    label={t("Page.Operation.Extraction.Labels.UploadFile", {
                      lngs: i18n.languages,
                      defaultValue: "Upload file:",
                    })}
                    required
                    tooltip={t(
                      "Page.Operation.Extraction.Tooltips.UploadFile",
                      { lngs: i18n.languages, defaultValue: "" }
                    )}
                  >
                    <Upload
                      maxCount={1}
                      fileList={selectedFileList}
                      disabled={current !== 1}
                      onChange={handleFileChange}
                      beforeUpload={preventRequest}
                      customRequest={customRequest}
                      accept=".xls,.xlsx,.xlsb"
                    >
                      <Button
                        disabled={current !== 1}
                        icon={<UploadOutlined />}
                      >
                        {t(
                          "Page.Operation.Extraction.Labels.UploadFileButton",
                          {
                            lngs: i18n.languages,
                            defaultValue: "Click to upload",
                          }
                        )}
                      </Button>
                    </Upload>
                    {selectedFileList.length === 0 && (
                      <div style={{ marginTop: '10px', color: 'rgba(0, 0, 0, 0.45)' }}>
                        <em>Note: In some cases, if the Excel file is opened and protected, the upload will fail. Please ensure the Excel file is closed before proceeding with the file upload. </em>
                      </div>
                    )}
                  </Form.Item>
                )}
                {/* Step 2 - source SQL */}
                {current >= 1 && selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL && (
                  <Form.Item
                    className={styles.mb10px}
                    label={t(
                      "Page.Operation.Extraction.Labels.SelectProjectDataSource",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Select project data source:",
                      }
                    )}
                    required
                    tooltip={t(
                      "Page.Operation.Extraction.Tooltips.SelectProjectDataSource",
                      { lngs: i18n.languages, defaultValue: "" }
                    )}
                  >
                    <AutoComplete
                      showSearch={true}
                      showArrow={true}
                      allowClear={true}
                      value={selectedProjectDataSource}
                      // onChange={onProjectDataSourceChange}
                      onClear={() => setSelectedProjectDataSource(null)}
                      onSelect={onProjectDataSourceSelect}
                      style={{ flex: 2 }}
                      disabled={current !== 1}
                      placeholder={t("General.Placeholders.EnterValue", {
                        lngs: i18n.languages,
                        defaultValue: "Enter value",
                      })}
                      options={projectSources
                        .filter((x: any) => x.sourceTypeID === 2)
                        .map((x: any) => {
                          return {
                            value: x.name,
                            label: x.name,
                            id: x.id.toString(),
                          };
                        })
                      }
                      filterOption={(inputValue: any, option: any) =>
                        option!.value
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                      }
                      // filterOption={(inputValue, option:any) =>
                      //   option!.value
                      //     .toUpperCase()
                      //     .indexOf(inputValue.toUpperCase()) !== -1
                      // }
                      filterSort={(optionA, optionB) =>
                        (optionA!.label as unknown as string)
                          ?.toLowerCase()
                          .localeCompare(
                            (optionB!.label as unknown as string)?.toLowerCase()
                          )
                      }
                    >
                      {/* {validationTypes.map((item: any) => {
                    return (
                      <Option value={item ? item : "no-type"}>
                        {item ? item : "No type"}
                      </Option>
                    );
                  })} */}
                    </AutoComplete>
                  </Form.Item>
                )}
                {/* Step 2 - source file-repository */}
                {current >= 1 && selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY && (
                  <Form.Item
                    className={styles.mb10px}
                    label={t(
                      "Page.Operation.Extraction.Labels.SelectProjectDataSource",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Select project data source:",
                      }
                    )}
                    required
                    tooltip={t(
                      "Page.Operation.Extraction.Tooltips.SelectProjectDataSource",
                      { lngs: i18n.languages, defaultValue: "" }
                    )}
                  >
                    <AutoComplete
                      showSearch={true}
                      showArrow={true}
                      allowClear={true}
                      onClear={() => setSelectedProjectDataSource(null)}
                      value={selectedProjectDataSource}
                      // onChange={onProjectDataSourceChange}
                      onSelect={onProjectDataSourceSelect}
                      style={{ flex: 2 }}
                      disabled={current !== 1}
                      placeholder={t("General.Placeholders.EnterValue", {
                        lngs: i18n.languages,
                        defaultValue: "Enter value",
                      })}
                      filterSort={(optionA, optionB) =>
                        (optionA!.label as unknown as string)
                          ?.toLowerCase()
                          .localeCompare(
                            (optionB!.label as unknown as string)?.toLowerCase()
                          )
                      }
                      options={projectSources
                        .filter((x: any) => x.sourceTypeID === 1)
                        .map((x: any) => {
                          return {
                            value: x.name,
                            label: x.name,
                            id: x.id.toString(),
                          };
                        })
                      }
                      filterOption={(inputValue: any, option: any) =>
                        option!.value
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                      }
                    // filterOption={(inputValue, option:any) =>
                    //   option!.value
                    //     .toUpperCase()
                    //     .indexOf(inputValue.toUpperCase()) !== -1
                    // }
                    // filterSort={(optionA, optionB) =>
                    //   optionA.label! < optionB.label! ? -1 : 1
                    // }
                    >
                      {/* {validationTypes.map((item: any) => {
                    return (
                      <Option value={item ? item : "no-type"}>
                        {item ? item : "No type"}
                      </Option>
                    );
                  })} */}
                    </AutoComplete>
                  </Form.Item>
                )}
                {/* Step 3 - source Excel */}
                {current >= 2 && selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER && (
                  <Form.Item
                    className={styles.mb10px}
                    label={t("Page.Operation.Extraction.Labels.TableType", {
                      lngs: i18n.languages,
                      defaultValue: "Table type:",
                    })}
                    required
                    tooltip={t("Page.Operation.Extraction.Tooltips.TableType", {
                      lngs: i18n.languages,
                      defaultValue: "",
                    })}
                  >
                    <Select
                      placeholder={t("General.Placeholders.SelectOption", {
                        lngs: i18n.languages,
                        defaultValue: "Select option",
                      })}
                      allowClear
                      disabled={current !== 2}
                      value={selectedTableType}
                      onChange={handleTableTypeChange}
                      onSelect={() => next()}
                    >
                      <Option value="new">
                        {t(
                          "Page.Operation.Extraction.DropdownItems.TableTypeNew",
                          { lngs: i18n.languages, defaultValue: "New table" }
                        )}
                      </Option>
                      <Option value="existing">
                        {t(
                          "Page.Operation.Extraction.DropdownItems.TableTypeExisting",
                          {
                            lngs: i18n.languages,
                            defaultValue: "Existing table",
                          }
                        )}
                      </Option>
                    </Select>
                  </Form.Item>
                )}
                {/* Step 3 - source SQL */}
                {current >= 2 &&
                  selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL &&
                  selectedProjectDataSource && (
                    <>
                      <Form.Item
                        className={styles.mb10px}
                      >
                        <Button
                          icon={<ExperimentOutlined />}
                          onClick={() => testConnection()}
                        >
                          Test connection
                        </Button>
                        {testConnectionState &&
                          testConnectionState === true && (
                            <span style={{ color: "green" }}>
                              Test connection succeeded.
                            </span>
                          )}
                        {testConnectionState === false && (
                          <span style={{ color: "red" }}>
                            Test connection failed.
                          </span>
                        )}
                      </Form.Item>
                      <Form.Item
                        label={t(
                          "Page.Operation.Extraction.Labels.SelectImportType",
                          {
                            lngs: i18n.languages,
                            defaultValue: "Select import type:",
                          }
                        )}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.SelectImportType",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          value={importType}
                          onSelect={onImportTypeChange}
                          style={{ flex: 2 }}
                          placeholder={t("General.Placeholders.EnterValue", {
                            lngs: i18n.languages,
                            defaultValue: "Enter value",
                          })}
                          filterSort={(optionA, optionB) =>
                            (optionA!.label as unknown as string)
                              ?.toLowerCase()
                              .localeCompare(
                                (optionB!.label as unknown as string)?.toLowerCase()
                              )
                          }
                          options={importTypes}
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        >
                        </Select>
                      </Form.Item>
                    </>
                  )
                }
                {current >= 3 &&
                  selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL &&
                  selectedProjectDataSource && (
                    <>
                      {importType === EXTRACTION_IMPORT_TYPES.DATABASE_OBJECT && (
                        <Form.Item
                          className={styles.mb10px}
                          label={t(
                            "Page.Operation.Extraction.Labels.SelectDatabaseObject",
                            {
                              lngs: i18n.languages,
                              defaultValue: "Select database object:",
                            }
                          )}
                          required
                          tooltip={t(
                            "Page.Operation.Extraction.Tooltips.SelectDatabaseObject",
                            { lngs: i18n.languages, defaultValue: "" }
                          )}
                        >
                          <AutoComplete
                            disabled={current !== 3}
                            showSearch={true}
                            showArrow={true}
                            allowClear={true}
                            value={selectedDatabaseObject}
                            onSelect={onSelectedDatabaseObjectSelect}
                            onChange={onSelectedDatabaseObjectChange}
                            style={{ flex: 2 }}
                            placeholder={t("General.Placeholders.EnterValue", {
                              lngs: i18n.languages,
                              defaultValue: "Enter value",
                            })}
                            options={databaseTables.map((x: any) => ({
                              value: x,
                              label: x,
                            }))}
                            filterOption={(inputValue: any, option: any) =>
                              option!.value
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            }
                          ></AutoComplete>
                        </Form.Item>
                      )}
                      {importType === EXTRACTION_IMPORT_TYPES.CUSTOM_QUERY && (
                        <Form.Item
                          label={t(
                            "Page.Operation.Extraction.Labels.SourceQuery",
                            { lngs: i18n.languages, defaultValue: "Source query:" }
                          )}
                          tooltip={t(
                            "Page.Operation.Extraction.Tooltips.SourceQuery",
                            { lngs: i18n.languages, defaultValue: "" }
                          )}
                          required
                        >
                          <TextArea
                            value={sourceQuery}
                            placeholder={
                              t("General.Placeholders.EnterValue", {
                                lngs: i18n.languages,
                                defaultValue: "Enter value",
                              })!
                            }
                            rows={5}
                            allowClear
                            onChange={onSourceQueryChange}
                          />
                        </Form.Item>
                      )}
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.GroupCode", {
                          lngs: i18n.languages,
                          defaultValue: "Group code:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.GroupCode",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          disabled={current !== 3}
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          onChange={onGroupCodeChange}
                          value={selectedGroupCode}
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          options={groupCodes.map((x: any) => ({
                            label: x.code,
                            value: x.code,
                          }))}
                          filterSort={(optionA, optionB) =>
                            optionA.value! < optionB.value! ? -1 : 1
                          }
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Entity", {
                          lngs: i18n.languages,
                          defaultValue: "Entity:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.Entity",
                          {
                            lngs: i18n.languages,
                            defaultValue: "",
                          }
                        )}
                      >
                        <Select
                          disabled={current !== 3}
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          onChange={onEntityChange}
                          value={selectedEntity}
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          options={entities.map((x: any) => ({
                            label: x.name,
                            value: x.id,
                          }))}
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          filterSort={(optionA: any, optionB: any) =>
                            (optionA!.label as unknown as string)
                              ?.toLowerCase()
                              .localeCompare(
                                (
                                  optionB!.label as unknown as string
                                )?.toLowerCase()
                              )
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        label={t(
                          "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.System",
                          {
                            lngs: i18n.languages,
                            defaultValue: "System:",
                          }
                        )}
                        tooltip={t(
                          "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.System",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          showSearch
                          options={systemOptions}
                          filterOption={(input, option) =>
                            typeof option?.label === 'string' &&
                            option.label.toLowerCase().includes(input.toLowerCase())
                          }
                          value={selectedSystemId}
                          onChange={setSelectedSystemId}
                          allowClear
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })!}
                        >
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="database"
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Database", {
                          lngs: i18n.languages,
                          defaultValue: "Database:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.Database",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          disabled={current !== 3}
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          value={database}
                          onChange={onDatabaseChange}
                          options={databases.map((x: any) => ({
                            label: x.name,
                            value: x.name,
                          }))}
                          filterSort={(optionA, optionB) =>
                            optionA.value! < optionB.value! ? -1 : 1
                          }
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Schema", {
                          lngs: i18n.languages,
                          defaultValue: "Schema:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.Schema",
                          {
                            lngs: i18n.languages,
                            defaultValue: "",
                          }
                        )}
                      >
                        <Input
                          disabled={current !== 3}
                          placeholder={
                            t("General.Placeholders.EnterValue", {
                              lngs: i18n.languages,
                              defaultValue: "Enter value",
                            }) ?? "Enter value"
                          }
                          value={schema}
                          onChange={(e) => onSchemaChange(e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Name", {
                          lngs: i18n.languages,
                          defaultValue: "Name:",
                        })}
                        required
                        tooltip={t("Page.Operation.Extraction.Tooltips.Name", {
                          lngs: i18n.languages,
                          defaultValue: "",
                        })}
                      >
                        <Input
                          disabled={current !== 3}
                          placeholder={
                            t("General.Placeholders.EnterValue", {
                              lngs: i18n.languages,
                              defaultValue: "Enter value",
                            }) ?? "Enter value"
                          }
                          value={name}
                          onChange={(e) => onNameChange(e.target.value)}
                        />
                      </Form.Item>
                    </>
                  )}

                {/* Step 4 - source SQL */}
                {current >= 3 &&
                  selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL &&
                  selectedProjectDataSource &&
                  (
                    <>
                      <Form.Item
                        label={t(
                          "Page.BatchProcessing.ProcessOverview.Labels.Occurrence",
                          {
                            lngs: i18n.languages,
                            defaultValue: "Occurrence:",
                          }
                        )}
                        tooltip={t(
                          "Page.BatchProcessing.ProcessOverview.Tooltips.Occurrence",
                          {
                            lngs: i18n.languages,
                            defaultValue: "",
                          }
                        )}
                      >
                        <Select
                          style={{ marginBottom: "24px" }}
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          allowClear
                          value={scheduleType}
                          onChange={setScheduleType}
                        >
                          <Option value={BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY}>
                            {t(
                              "Page.BatchProcessing.ProcessOverview.OptionOccurrence.Immediately",
                              {
                                lngs: i18n.languages,
                                defaultValue: BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY,
                              }
                            )}
                          </Option>
                          <Option value={BATCH_PROCESSING_OCCURRENCE_TYPE.ONE_TIME}>
                            {t(
                              "Page.BatchProcessing.ProcessOverview.OptionOccurrence.OneTime",
                              {
                                lngs: i18n.languages,
                                defaultValue: "One Time",
                              }
                            )}
                          </Option>
                          <Option value={BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING}>
                            {t(
                              "Page.BatchProcessing.ProcessOverview.OptionOccurrence.Recurring",
                              {
                                lngs: i18n.languages,
                                defaultValue: BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING,
                              }
                            )}
                          </Option>
                        </Select>
                        <PickerWithType
                          type={scheduleType}
                          onChange={(value: any) => console.log(value)}
                        />
                      </Form.Item>
                    </>
                  )}
                {/* { Step 3 - file-repository } */}
                {current >= 2 &&
                  selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY &&
                  selectedProjectDataSource && (
                    <>
                      <Form.Item
                        className={styles.mb10px}
                      >
                        <Button
                          icon={<ExperimentOutlined />}
                          onClick={() => testFileRepositoryPath()}
                        >
                          Test connection
                        </Button>
                        {testConnectionState &&
                          testConnectionState === true && (
                            <span style={{ color: "green" }}>
                              Test connection succeeded.
                            </span>
                          )}
                        {testConnectionState === false && (
                          <span style={{ color: "red" }}>
                            Test connection failed.
                          </span>
                        )}
                      </Form.Item>
                      <Form.Item
                        label={t(
                          "Page.Operation.Extraction.Labels.SelectFile",
                          {
                            lngs: i18n.languages,
                            defaultValue: "Select file:",
                          }
                        )}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.SelectFile",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          value={selectedFileName}
                          onSelect={onFileNameChange}
                          style={{ flex: 2 }}
                          filterSort={(optionA, optionB) =>
                            (optionA!.label as unknown as string)
                              ?.toLowerCase()
                              .localeCompare(
                                (optionB!.label as unknown as string)?.toLowerCase()
                              )
                          }
                          placeholder={t("General.Placeholders.EnterValue", {
                            lngs: i18n.languages,
                            defaultValue: "Enter value",
                          })}
                          options={fileRepositoryFileNames.map(f => ({
                            id: f,
                            value: f
                          }))}
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        >
                        </Select>
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.GroupCode", {
                          lngs: i18n.languages,
                          defaultValue: "Group code:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.GroupCode",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          onChange={onGroupCodeChange}
                          value={selectedGroupCode}
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          filterSort={(optionA, optionB) =>
                            (optionA!.value as unknown as string)
                              ?.toLowerCase()
                              .localeCompare(
                                (optionB!.value as unknown as string)?.toLowerCase()
                              )
                          }
                          options={groupCodes.map((x: any) => ({
                            label: x.code,
                            value: x.code,
                          }))}
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Entity", {
                          lngs: i18n.languages,
                          defaultValue: "Entity:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.Entity",
                          {
                            lngs: i18n.languages,
                            defaultValue: "",
                          }
                        )}
                      >
                        <Select
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          onChange={onEntityChange}
                          value={selectedEntity}
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          options={entities.map((x: any) => ({
                            label: x.name,
                            value: x.id,
                          }))}
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          filterSort={(optionA: any, optionB: any) =>
                            (optionA!.label as unknown as string)
                              ?.toLowerCase()
                              .localeCompare(
                                (
                                  optionB!.label as unknown as string
                                )?.toLowerCase()
                              )
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        label={t(
                          "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.System",
                          {
                            lngs: i18n.languages,
                            defaultValue: "System:",
                          }
                        )}
                        tooltip={t(
                          "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.System",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          showSearch
                          options={systemOptions}
                          filterOption={(input, option) =>
                            typeof option?.label === 'string' &&
                            option.label.toLowerCase().includes(input.toLowerCase())
                          }
                          value={selectedSystemId}
                          onChange={setSelectedSystemId}
                          allowClear
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })!}
                        >
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="database"
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Database", {
                          lngs: i18n.languages,
                          defaultValue: "Database:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.Database",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          value={database}
                          onChange={onDatabaseChange}
                          options={databases.map((x: any) => ({
                            label: x.name,
                            value: x.name,
                          }))}
                          filterSort={(optionA, optionB) =>
                            optionA.value! < optionB.value! ? -1 : 1
                          }
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Schema", {
                          lngs: i18n.languages,
                          defaultValue: "Schema:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.Schema",
                          {
                            lngs: i18n.languages,
                            defaultValue: "",
                          }
                        )}
                      >
                        <Input
                          placeholder={
                            t("General.Placeholders.EnterValue", {
                              lngs: i18n.languages,
                              defaultValue: "Enter value",
                            }) ?? "Enter value"
                          }
                          value={schema}
                          onChange={(e) => onSchemaChange(e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Name", {
                          lngs: i18n.languages,
                          defaultValue: "Name:",
                        })}
                        required
                        tooltip={t("Page.Operation.Extraction.Tooltips.Name", {
                          lngs: i18n.languages,
                          defaultValue: "",
                        })}
                      >
                        <Input
                          placeholder={
                            t("General.Placeholders.EnterValue", {
                              lngs: i18n.languages,
                              defaultValue: "Enter value",
                            }) ?? "Enter value"
                          }
                          value={name}
                          onChange={(e) => onNameChange(e.target.value)}
                        />
                      </Form.Item>
                    </>
                  )}
                {/* Step 4 - file-repository */}
                {current >= 3 &&
                  selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY &&
                  (
                    <>
                      <Form.Item
                        label={t(
                          "Page.BatchProcessing.ProcessOverview.Labels.Occurrence",
                          {
                            lngs: i18n.languages,
                            defaultValue: "Occurrence:",
                          }
                        )}
                        tooltip={t(
                          "Page.BatchProcessing.ProcessOverview.Tooltips.Occurrence",
                          {
                            lngs: i18n.languages,
                            defaultValue: "",
                          }
                        )}
                      >
                        <Select
                          style={{ marginBottom: "24px" }}
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          allowClear
                          value={scheduleType}
                          onChange={setScheduleType}
                        >
                          <Option value={BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY}>
                            {t(
                              "Page.BatchProcessing.ProcessOverview.OptionOccurrence.Immediately",
                              {
                                lngs: i18n.languages,
                                defaultValue: BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY,
                              }
                            )}
                          </Option>
                          <Option value={BATCH_PROCESSING_OCCURRENCE_TYPE.ONE_TIME}>
                            {t(
                              "Page.BatchProcessing.ProcessOverview.OptionOccurrence.OneTime",
                              {
                                lngs: i18n.languages,
                                defaultValue: "One Time",
                              }
                            )}
                          </Option>
                          <Option value={BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING}>
                            {t(
                              "Page.BatchProcessing.ProcessOverview.OptionOccurrence.Recurring",
                              {
                                lngs: i18n.languages,
                                defaultValue: BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING,
                              }
                            )}
                          </Option>
                        </Select>
                        <PickerWithType
                          type={scheduleType}
                          onChange={(value: any) => console.log(value)}
                        />
                      </Form.Item>
                    </>
                  )}
                {current >= 3 &&
                  selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
                  selectedTableType === "new" && (
                    <div>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.GroupCode", {
                          lngs: i18n.languages,
                          defaultValue: "Group code:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.GroupCode",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          onChange={onGroupCodeChange}
                          value={selectedGroupCode}
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          options={groupCodes.map((x: any) => ({
                            label: x.code,
                            value: x.code,
                          }))}
                          filterSort={(optionA, optionB) =>
                            optionA.value! < optionB.value! ? -1 : 1
                          }
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Entity", {
                          lngs: i18n.languages,
                          defaultValue: "Entity:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.Entity",
                          {
                            lngs: i18n.languages,
                            defaultValue: "",
                          }
                        )}
                      >
                        <Select
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          onChange={onEntityChange}
                          value={selectedEntity}
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          options={entities.map((x: any) => ({
                            label: x.name,
                            value: x.id,
                          }))}
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          filterSort={(optionA: any, optionB: any) =>
                            (optionA!.label as unknown as string)
                              ?.toLowerCase()
                              .localeCompare(
                                (
                                  optionB!.label as unknown as string
                                )?.toLowerCase()
                              )
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        label={t(
                          "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.System",
                          {
                            lngs: i18n.languages,
                            defaultValue: "System:",
                          }
                        )}
                        tooltip={t(
                          "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.System",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          showSearch
                          options={systemOptions}
                          filterOption={(input, option) =>
                            typeof option?.label === 'string' &&
                            option.label.toLowerCase().includes(input.toLowerCase())
                          }
                          value={selectedSystemId}
                          onChange={setSelectedSystemId}
                          allowClear
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })!}
                        >
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="database"
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Database", {
                          lngs: i18n.languages,
                          defaultValue: "Database:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.Database",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          value={database}
                          onChange={onDatabaseChange}
                          options={databases.map((x: any) => ({
                            label: x.name,
                            value: x.name,
                          }))}
                          filterSort={(optionA, optionB) =>
                            optionA.value! < optionB.value! ? -1 : 1
                          }
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Schema", {
                          lngs: i18n.languages,
                          defaultValue: "Schema:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.Schema",
                          {
                            lngs: i18n.languages,
                            defaultValue: "",
                          }
                        )}
                      >
                        <Input
                          placeholder={
                            t("General.Placeholders.EnterValue", {
                              lngs: i18n.languages,
                              defaultValue: "Enter value",
                            }) ?? "Enter value"
                          }
                          value={schema}
                          onChange={(e) => onSchemaChange(e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Name", {
                          lngs: i18n.languages,
                          defaultValue: "Name:",
                        })}
                        required
                        tooltip={t("Page.Operation.Extraction.Tooltips.Name", {
                          lngs: i18n.languages,
                          defaultValue: "",
                        })}
                      >
                        <Input
                          placeholder={
                            t("General.Placeholders.EnterValue", {
                              lngs: i18n.languages,
                              defaultValue: "Enter value",
                            }) ?? "Enter value"
                          }
                          value={name}
                          onChange={(e) => onNameChange(e.target.value)}
                        />
                      </Form.Item>
                    </div>
                  )}
                {current >= 3 &&
                  selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
                  selectedTableType === "existing" && (
                    <div>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Operation", {
                          lngs: i18n.languages,
                          defaultValue: "Operation:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Labels.Operation",
                          {
                            lngs: i18n.languages,
                            defaultValue: "",
                          }
                        )}
                      >
                        <Select
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          onChange={onOperationChange}
                          value={selectedOperation}
                          allowClear
                          showArrow
                          showSearch
                        >
                          <Option value="append">
                            {t(
                              "Page.Operation.Extraction.DropdownItems.OperationAppend",
                              { lngs: i18n.languages, defaultValue: "Append" }
                            )}
                          </Option>
                          <Option value="overwrite">
                            {t(
                              "Page.Operation.Extraction.DropdownItems.OperationOverwrite",
                              {
                                lngs: i18n.languages,
                                defaultValue: "Overwrite",
                              }
                            )}
                          </Option>
                        </Select>
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.GroupCode", {
                          lngs: i18n.languages,
                          defaultValue: "Group code:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.GroupCode",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          onChange={onGroupCodeChange}
                          value={selectedGroupCode}
                          allowClear
                          showArrow
                          showSearch
                          options={groupCodes.map((x: any) => ({
                            label: x.code,
                            value: x.code,
                          }))}
                          filterSort={(optionA, optionB) =>
                            optionA.value! < optionB.value! ? -1 : 1
                          }
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Entity", {
                          lngs: i18n.languages,
                          defaultValue: "Entity:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.Entity",
                          {
                            lngs: i18n.languages,
                            defaultValue: "",
                          }
                        )}
                      >
                        <Select
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          onChange={onEntityChange}
                          value={selectedEntity}
                          allowClear
                          showArrow
                          showSearch
                          options={entities.map((x: any) => ({
                            label: x.name,
                            value: x.id,
                          }))}
                          filterSort={(optionA, optionB) =>
                            optionA.label! < optionB.label! ? -1 : 1
                          }
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        label={t(
                          "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.System",
                          {
                            lngs: i18n.languages,
                            defaultValue: "System:",
                          }
                        )}
                        tooltip={t(
                          "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.System",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          showSearch
                          options={systemOptions}
                          filterOption={(input, option) =>
                            typeof option?.label === 'string' &&
                            option.label.toLowerCase().includes(input.toLowerCase())
                          }
                          value={selectedSystemId}
                          onChange={setSelectedSystemId}
                          allowClear
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })!}
                        >
                        </Select>
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Table", {
                          lngs: i18n.languages,
                          defaultValue: "Table:",
                        })}
                        required
                        tooltip={t("Page.Operation.Extraction.Tooltips.Table", {
                          lngs: i18n.languages,
                          defaultValue: "",
                        })}
                      >
                        <Select
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          onChange={onTableChange}
                          value={selectedTable}
                          allowClear
                          options={targetTables.map((x: any) => ({
                            label: x.name,
                            value: x.id,
                          }))}
                          filterSort={(optionA, optionB) =>
                            optionA.label! < optionB.label! ? -1 : 1
                          }
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        ></Select>
                      </Form.Item>
                    </div>
                  )}





















                {/* Step 2 - source SharePoint */}
                {current >= 1 && selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT && (
                  <Form.Item
                    className={styles.mb10px}
                    label={t(
                      "Page.Operation.Extraction.Labels.SelectProjectDataSource",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Select project data source:",
                      }
                    )}
                    required
                    tooltip={t(
                      "Page.Operation.Extraction.Tooltips.SelectProjectDataSource",
                      { lngs: i18n.languages, defaultValue: "" }
                    )}
                  >
                    <AutoComplete
                      showSearch={true}
                      showArrow={true}
                      allowClear={true}
                      onClear={() => setSelectedProjectDataSource(null)}
                      value={selectedProjectDataSource}
                      // onChange={onProjectDataSourceChange}
                      onSelect={onProjectDataSourceSelect}
                      style={{ flex: 2 }}
                      disabled={current !== 1}
                      placeholder={t("General.Placeholders.EnterValue", {
                        lngs: i18n.languages,
                        defaultValue: "Enter value",
                      })}
                      options={projectSources
                        .filter((x: any) => x.sourceTypeID === 3)
                        .map((x: any) => {
                          return {
                            value: x.name,
                            label: x.name,
                            id: x.id.toString(),
                          };
                        })
                      }
                      filterOption={(inputValue: any, option: any) =>
                        option!.value
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA!.label as unknown as string)
                          ?.toLowerCase()
                          .localeCompare(
                            (optionB!.label as unknown as string)?.toLowerCase()
                          )
                      }
                    // filterOption={(inputValue, option:any) =>
                    //   option!.value
                    //     .toUpperCase()
                    //     .indexOf(inputValue.toUpperCase()) !== -1
                    // }
                    // filterSort={(optionA, optionB) =>
                    //   optionA.label! < optionB.label! ? -1 : 1
                    // }
                    >
                      {/* {validationTypes.map((item: any) => {
                    return (
                      <Option value={item ? item : "no-type"}>
                        {item ? item : "No type"}
                      </Option>
                    );
                  })} */}
                    </AutoComplete>
                  </Form.Item>
                )}
                {/* { Step 3 - SharePoint } */}
                {current >= 2 &&
                  selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT &&
                  selectedProjectDataSource && (
                    <>
                      <Form.Item
                        className={styles.mb10px}
                      >
                        <Button
                          icon={<ExperimentOutlined />}
                          onClick={() => testSharePointConnection()}
                        >
                          Test connection
                        </Button>
                        {testConnectionState &&
                          testConnectionState === true && (
                            <span style={{ color: "green" }}>
                              Test connection succeeded.
                            </span>
                          )}
                        {testConnectionState === false && (
                          <span style={{ color: "red" }}>
                            Test connection failed.
                          </span>
                        )}
                      </Form.Item>
                      <Form.Item
                        label={t(
                          "Page.Operation.Extraction.Labels.SelectFile",
                          {
                            lngs: i18n.languages,
                            defaultValue: "Select file:",
                          }
                        )}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.SelectFile",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          value={selectedFileName}
                          onSelect={onFileNameChange}
                          style={{ flex: 2 }}
                          placeholder={t("General.Placeholders.EnterValue", {
                            lngs: i18n.languages,
                            defaultValue: "Enter value",
                          })}
                          options={sharepointFileNames.map(f => ({
                            value: f?.id,
                            label: f?.name
                          }))}
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        >
                        </Select>
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.GroupCode", {
                          lngs: i18n.languages,
                          defaultValue: "Group code:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.GroupCode",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          onChange={onGroupCodeChange}
                          value={selectedGroupCode}
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          options={groupCodes.map((x: any) => ({
                            label: x.code,
                            value: x.code,
                          }))}
                          filterSort={(optionA, optionB) =>
                            (optionA!.label as unknown as string)
                              ?.toLowerCase()
                              .localeCompare(
                                (optionB!.label as unknown as string)?.toLowerCase()
                              )
                          }
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Entity", {
                          lngs: i18n.languages,
                          defaultValue: "Entity:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.Entity",
                          {
                            lngs: i18n.languages,
                            defaultValue: "",
                          }
                        )}
                      >
                        <Select
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          onChange={onEntityChange}
                          value={selectedEntity}
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          options={entities.map((x: any) => ({
                            label: x.name,
                            value: x.id,
                          }))}
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          filterSort={(optionA: any, optionB: any) =>
                            (optionA!.label as unknown as string)
                              ?.toLowerCase()
                              .localeCompare(
                                (
                                  optionB!.label as unknown as string
                                )?.toLowerCase()
                              )
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        label={t(
                          "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.System",
                          {
                            lngs: i18n.languages,
                            defaultValue: "System:",
                          }
                        )}
                        tooltip={t(
                          "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.System",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          showSearch
                          options={systemOptions}
                          filterOption={(input, option) =>
                            typeof option?.label === 'string' &&
                            option.label.toLowerCase().includes(input.toLowerCase())
                          }
                          value={selectedSystemId}
                          onChange={setSelectedSystemId}
                          allowClear
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })!}
                        >
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="database"
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Database", {
                          lngs: i18n.languages,
                          defaultValue: "Database:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.Database",
                          { lngs: i18n.languages, defaultValue: "" }
                        )}
                      >
                        <Select
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          value={database}
                          onChange={onDatabaseChange}
                          options={databases.map((x: any) => ({
                            label: x.name,
                            value: x.name,
                          }))}
                          filterSort={(optionA, optionB) =>
                            optionA.value! < optionB.value! ? -1 : 1
                          }
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Schema", {
                          lngs: i18n.languages,
                          defaultValue: "Schema:",
                        })}
                        required
                        tooltip={t(
                          "Page.Operation.Extraction.Tooltips.Schema",
                          {
                            lngs: i18n.languages,
                            defaultValue: "",
                          }
                        )}
                      >
                        <Input
                          placeholder={
                            t("General.Placeholders.EnterValue", {
                              lngs: i18n.languages,
                              defaultValue: "Enter value",
                            }) ?? "Enter value"
                          }
                          value={schema}
                          onChange={(e) => onSchemaChange(e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        className={styles.mb10px}
                        label={t("Page.Operation.Extraction.Labels.Name", {
                          lngs: i18n.languages,
                          defaultValue: "Name:",
                        })}
                        required
                        tooltip={t("Page.Operation.Extraction.Tooltips.Name", {
                          lngs: i18n.languages,
                          defaultValue: "",
                        })}
                      >
                        <Input
                          placeholder={
                            t("General.Placeholders.EnterValue", {
                              lngs: i18n.languages,
                              defaultValue: "Enter value",
                            }) ?? "Enter value"
                          }
                          value={name}
                          onChange={(e) => onNameChange(e.target.value)}
                        />
                      </Form.Item>
                    </>
                  )}
                {/* Step 4 - SharePoint */}
                {current >= 3 &&
                  selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT &&
                  (
                    <>
                      <Form.Item
                        label={t(
                          "Page.BatchProcessing.ProcessOverview.Labels.Occurrence",
                          {
                            lngs: i18n.languages,
                            defaultValue: "Occurrence:",
                          }
                        )}
                        tooltip={t(
                          "Page.BatchProcessing.ProcessOverview.Tooltips.Occurrence",
                          {
                            lngs: i18n.languages,
                            defaultValue: "",
                          }
                        )}
                      >
                        <Select
                          style={{ marginBottom: "24px" }}
                          placeholder={t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                          })}
                          allowClear
                          value={scheduleType}
                          onChange={setScheduleType}
                        >
                          <Option value={BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY}>
                            {t(
                              "Page.BatchProcessing.ProcessOverview.OptionOccurrence.Immediately",
                              {
                                lngs: i18n.languages,
                                defaultValue: BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY,
                              }
                            )}
                          </Option>
                          <Option value={BATCH_PROCESSING_OCCURRENCE_TYPE.ONE_TIME}>
                            {t(
                              "Page.BatchProcessing.ProcessOverview.OptionOccurrence.OneTime",
                              {
                                lngs: i18n.languages,
                                defaultValue: "One Time",
                              }
                            )}
                          </Option>
                          <Option value={BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING}>
                            {t(
                              "Page.BatchProcessing.ProcessOverview.OptionOccurrence.Recurring",
                              {
                                lngs: i18n.languages,
                                defaultValue: BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING,
                              }
                            )}
                          </Option>
                        </Select>
                        <PickerWithType
                          type={scheduleType}
                          onChange={(value: any) => console.log(value)}
                        />
                      </Form.Item>
                    </>
                  )}
              </Form>
            )}
            {current >= 4 &&
              (selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER || selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY
                || selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT) &&
              isExtracting &&
              !isLoading && (
                <Form
                  layout="vertical"
                  wrapperCol={{ span: 8 }}
                  style={{ height: "95%", overflowY: "auto", scrollbarWidth: "thin" }}
                >
                  <Form.Item
                    className={styles.mb10px}
                    label={t("Page.Operation.Extraction.Labels.ColumnHeaders", {
                      lngs: i18n.languages,
                      defaultValue: "Column headers:",
                    })}
                    required
                    tooltip={t(
                      "Page.Operation.Extraction.Tooltips.ColumnHeaders",
                      { lngs: i18n.languages, defaultValue: "" }
                    )}
                  >
                    <Spin></Spin>
                  </Form.Item>
                  <span style={{ fontStyle: "italic" }}>
                    {t(
                      "Page.Operation.Extraction.Labels.LargeDataExtractionLongProcessingNote",
                      {
                        lngs: i18n.languages,
                        defaultValue:
                          "Note: Large files might take few minutes to complete processing.",
                      }
                    )}
                  </span>
                </Form>
              )}
            {current >= 4 &&
              selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER &&
              !isExtracting &&
              !isLoading &&
              !extractionDone && (
                <Form
                  layout="vertical"
                  wrapperCol={{ span: 8 }}
                  style={{ height: "95%", overflowY: "scroll", scrollbarWidth: "thin" }}
                >
                  {/* <Form.Item className={styles.mb0px} label="Column headers:" required tooltip="Confirm column header names"></Form.Item> */}
                  <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                    {t("Page.Operation.Extraction.Labels.ColumnHeaders", {
                      lngs: i18n.languages,
                      defaultValue: "Column headers:",
                    })}
                  </div>
                  <div className={styles.columnsNameTable}>
                    {existingColumns.length > 0 &&
                      <Form.Item className={[styles.mb10px, styles.columnsNameTableCol].join(' ')}>
                        <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                          {t("Page.Operation.Extraction.Labels.ExistingColumns", {
                            lngs: i18n.languages,
                            defaultValue: "Existing column headers",
                          })}
                        </div>
                        {existingColumns.map((x: any, idx: any) => (
                          <Form.Item className={styles.mb10px} required tooltip={x}>
                            <Input
                              placeholder={importedColumns[idx]}
                              value={x}
                            />

                          </Form.Item>
                        ))}
                      </Form.Item>
                    }
                    <Form.Item className={[styles.mb10px, styles.columnsNameTableCol].join(' ')}>
                      {existingColumns.length > 0 &&
                        <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                          {t("Page.Operation.Extraction.Labels.ExtractedColumns", {
                            lngs: i18n.languages,
                            defaultValue: "Extracted column headers",
                          })}
                        </div>}
                      {extractedColumns.map((x: any, idx: any) => (
                        <Form.Item className={styles.mb10px} required tooltip={x}>
                          <Space>
                            <Input
                              placeholder={importedColumns[idx]}
                              value={x}
                              style={
                                (isDuplicateColumnName(idx)
                                  ? { border: "1px solid red" }
                                  : isNewColumn(x)
                                    ? { backgroundColor: "#7BBDB1", color: "white" }
                                    : {})
                              }
                              onChange={(e) =>
                                onHeaderColumnChange(e.target.value, idx)
                              }
                            />
                            <Checkbox
                              checked={checkedKeys.includes(extractedColumns[idx])}
                              onChange={handleCheckboxChange(idx)}
                            >
                              isKey
                            </Checkbox>
                          </Space>
                        </Form.Item>
                      ))}
                    </Form.Item>
                  </div>
                </Form>
              )}
            {current >= 4 &&
              (selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER || selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY
                || selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT) &&
              isLoading && (
                <Form
                  layout="vertical"
                  wrapperCol={{ span: 8 }}
                  style={{ height: "95%", overflowY: "scroll", scrollbarWidth: "thin" }}
                >
                  <Form.Item className={styles.mb10px} required>
                    <Spin></Spin>
                  </Form.Item>
                  <span style={{ fontStyle: "italic" }}>
                    {t(
                      "Page.Operation.Extraction.Labels.LargeDataExtractionLongProcessingNote",
                      {
                        lngs: i18n.languages,
                        defaultValue:
                          "Note: Large files might take few minutes to complete processing.",
                      }
                    )}
                  </span>
                </Form>
              )}
            {current >= 4 &&
              selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL &&
              isLoading && (
                <Form
                  layout="vertical"
                  wrapperCol={{ span: 8 }}
                  style={{ height: "95%", overflowY: "scroll", scrollbarWidth: "thin" }}
                >
                  <Form.Item className={styles.mb10px} required>
                    <Spin></Spin>
                  </Form.Item>
                  <span style={{ fontStyle: "italic" }}>
                    {t(
                      "Page.Operation.Extraction.Labels.LargeDatasetExtractionLongProcessingNote",
                      {
                        lngs: i18n.languages,
                        defaultValue:
                          "Note: Large datasets might take longer time to complete processing.",
                      }
                    )}
                  </span>
                </Form>
              )}
            {current >= 4 &&
              (selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER || selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY
                || selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT || selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL) &&
              extractionDone && extractionSuccessful && (
                <Form
                  layout="vertical"
                  wrapperCol={{ span: 8 }}
                  className={styles.extractionCompletedForm}
                >
                  <CheckCircleOutlined className={styles.extractionCompletedFormIconSuccess} />
                  <div className={styles.extractionCompletedFormTitle}>
                    {t("Page.Operation.Import.Labels.Success", {
                      lngs: i18n.languages,
                      defaultValue: "Success",
                    })}
                  </div>
                  {extractionRecords ? (
                    <div className={styles.extractionCompletedFormDescription}>
                      {t("Page.Operation.Import.Notifications.Import.CreateSuccessDescription", {
                        lngs: i18n.languages,
                        defaultValue: `Extraction completed. Extracted ${extractionRecords} records.`,
                      })}
                    </div>
                  ) : (
                    <div className={styles.extractionCompletedFormDescription}>
                      {t("Page.Operation.Import.Notifications.Import.CreateSuccessDescriptionNoRecords", {
                        lngs: i18n.languages,
                        defaultValue: `Extraction completed.`,
                      })}
                    </div>
                  )}

                  <div style={{ display: "flex", flexDirection: "row", gap: "10px", width: '100%', justifyContent: "center" }}>
                    <Button
                      shape="default"
                      block
                      type="primary"
                      htmlType="submit"
                      onClick={() => refreshPage()}
                      className={styles.extractionCompletedFormButton}>
                      {t("Page.Operation.Import.Labels.StartNewExtraction", {
                        lngs: i18n.languages,
                        defaultValue: `Start new extraction`,
                      })}
                    </Button>

                    <Button
                      shape="default"
                      block
                      type="primary"
                      htmlType="submit"
                      onClick={() => goToTableSetup()}
                      className={styles.extractionCompletedFormButton}>
                      {t("Page.Operation.Import.Labels.GoToTableSetup", {
                        lngs: i18n.languages,
                        defaultValue: `Go to Table Setup`,
                      })}
                    </Button>
                  </div>

                </Form>
              )}
            {current >= 4 &&
              (selectedSource === EXTRACTION_SOURCE_TYPES.FILE_ON_THIS_COMPUTER || selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY
                || selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT || selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL) &&
              extractionDone && !extractionSuccessful && (
                <Form
                  layout="vertical"
                  wrapperCol={{ span: 8 }}
                  className={styles.extractionCompletedForm}
                >
                  <CloseCircleOutlined className={styles.extractionCompletedFormIconError} />
                  <div className={styles.extractionCompletedFormTitle}>
                    {t("Page.Operation.Import.Labels.Error", {
                      lngs: i18n.languages,
                      defaultValue: "Error",
                    })}
                  </div>
                  <div className={styles.extractionCompletedFormDescription}>
                    {t("Page.Operation.Import.Notifications.Import.CreateFailedDescription", {
                      lngs: i18n.languages,
                      defaultValue: `Extraction failed. ${extractionFailedDescription}`,
                    })}
                  </div>
                  <div className={styles.extractionCompletedFormButtonGroup}>
                    <Button
                      shape="default"
                      block
                      type="default"
                      htmlType="submit"
                      onClick={() => prev()}
                      className={styles.extractionCompletedFormButton}>
                      {t("Page.Operation.Import.Labels.BackToExistingForm", {
                        lngs: i18n.languages,
                        defaultValue: `Back to existing form`,
                      })}
                    </Button>
                    <Button
                      shape="default"
                      block
                      type="primary"
                      htmlType="submit"
                      onClick={() => refreshPage()}
                      className={styles.extractionCompletedFormButton}>
                      {t("Page.Operation.Import.Labels.StartNewExtraction", {
                        lngs: i18n.languages,
                        defaultValue: `Start new extraction`,
                      })}
                    </Button>
                  </div>
                </Form>
              )}
            {current >= 4 &&
              selectedSource === EXTRACTION_SOURCE_TYPES.FILE_REPOSITORY &&
              !isExtracting &&
              !isLoading &&
              !extractionDone && (
                <>
                  {isLoading || isExtracting ? (
                    <div style={{ marginLeft: '50%', marginTop: '50%' }}>
                      <Spin />
                    </div>
                  ) : (
                    extractedColumns.map((x, idx) => (
                      <Form.Item className={styles.mb10px} required tooltip={x} key={idx}>
                        <Space>
                          <Input
                            disabled
                            placeholder={importedColumns[idx]}
                            value={x}
                            style={
                              isDuplicateColumnName(idx)
                                ? { border: "1px solid red" }
                                : isNewColumn(x)
                                  ? { backgroundColor: "#7BBDB1", color: "white" }
                                  : {}
                            }
                            onChange={(e) => onHeaderColumnChange(e.target.value, idx)}
                          />
                          <Checkbox
                            checked={checkedKeys.includes(extractedColumns[idx])}
                            onChange={handleCheckboxChange(idx)}
                          >
                            isKey
                          </Checkbox>
                        </Space>
                      </Form.Item>
                    ))
                  )}
                </>
              )}
            {current === 4 && selectedSource === EXTRACTION_SOURCE_TYPES.SHAREPOINT &&
              !isExtracting &&
              !isLoading &&
              !extractionDone && (
                <>
                  {isLoading || isExtracting ? (
                    <div style={{ marginLeft: '50%', marginTop: '50%' }}>
                      <Spin />
                    </div>
                  ) : (
                    extractedColumns.map((x, idx) => (
                      <Form.Item className={styles.mb10px} required tooltip={x} key={idx}>
                        <Space>
                          <Input
                            disabled
                            placeholder={importedColumns[idx]}
                            value={x}
                            style={
                              isDuplicateColumnName(idx)
                                ? { border: "1px solid red" }
                                : isNewColumn(x)
                                  ? { backgroundColor: "#7BBDB1", color: "white" }
                                  : {}
                            }
                            onChange={(e) => onHeaderColumnChange(e.target.value, idx)}
                          />
                          <Checkbox
                            checked={checkedKeys.includes(extractedColumns[idx])}
                            onChange={handleCheckboxChange(idx)}
                          >
                            isKey
                          </Checkbox>
                        </Space>
                      </Form.Item>
                    ))
                  )}
                </>
              )}
            {current === 4 && selectedSource === EXTRACTION_SOURCE_TYPES.MS_SQL &&
              !isExtracting &&
              !isLoading &&
              !extractionDone && (
                <>
                  {isLoading || isExtracting ? (
                    <div style={{ marginLeft: '50%', marginTop: '50%' }}>
                      <Spin />
                    </div>
                  ) : (
                    extractedColumns.map((x, idx) => (
                      <Form.Item className={styles.mb10px} required tooltip={x} key={idx}>
                        <Space>
                          <Input
                            disabled
                            placeholder={importedColumns[idx]}
                            value={x}
                            style={
                              isDuplicateColumnName(idx)
                                ? { border: "1px solid red" }
                                : isNewColumn(x)
                                  ? { backgroundColor: "#7BBDB1", color: "white" }
                                  : {}
                            }
                            onChange={(e) => onHeaderColumnChange(e.target.value, idx)}
                          />
                          <Checkbox
                            checked={checkedKeys.includes(extractedColumns[idx])}
                            onChange={handleCheckboxChange(idx)}
                          >
                            isKey
                          </Checkbox>
                        </Space>
                      </Form.Item>
                    ))
                  )}
                </>
              )}
          </div>
        </div>
      </div>
      <Modal
        title={t("Page.Operation.Import.Labels.ProceedToBatchProcessing.Title", {
          lngs: i18n.languages,
          defaultValue: "Proceed to Batch Processing?",
        })}
        okText={t("Page.Operation.Import.Labels.ProceedToBatchProcessing.SeeTheQueue", {
          lngs: i18n.languages,
          defaultValue: "See the queue",
        })}

        cancelText={t("Page.Operation.Import.Labels.ProceedToBatchProcessing.EnterANewExtraction", {
          lngs: i18n.languages,
          defaultValue: "Enter a new extraction",
        })}
        visible={isRedirectModalOpen}
        onOk={handleRedirectModalOk}
        onCancel={handleRedirectModalCancel}>
        <p>{t("Page.Operation.Import.Labels.ProceedToBatchProcessing.ContentPartOne", {
          lngs: i18n.languages,
          defaultValue: "Your extraction has been added to the batch processing queue for",
        })} {t("Page.Operation.Import.Labels.ProceedToBatchProcessing.ContentPartScheduled", {
          lngs: i18n.languages,
          defaultValue: "processing at the scheduled time(s)",
        })}. {t("Page.Operation.Import.Labels.ProceedToBatchProcessing.ContentPartTwo", {
          lngs: i18n.languages,
          defaultValue: "Do you want to see the queue or enter a new extraction?",
        })}
        </p>
      </Modal>
    </div>
  );
};
export default Extraction;
